module.exports = {
  PleaseChooseJob: 'Vui lòng chọn order.',
  NoSearchingInfo: 'Không nhập thông tin truy vấn.',
  NoRecordMeetTheConditions: 'Không có hồ sơ nào đáp ứng yêu cầu được truy vấn.',
  Error: 'Lỗi được tạo ra.',
  Locked: 'Đã khóa',
  UnKnownStatus: 'Trạng thái không rõ',
  CloseDetailWindow: 'Đóng cửa sổ Chi tiết',
  AdvancedSearch: 'Truy vấn nâng cao',
  NoCustomersFoundPleaseRefreshCache: 'Khách hàng không tồn tại, hãy thử đặt lại bộ nhớ cache!',
  SelectedMonthHasBeenClosed: 'Tháng hiện tại được chọn đã được đóng.',
  AccountClosedSuccessfully: 'Đóng sổ thành công.',
  PleaseSelectClosingRecord: 'Vui lòng chọn Closing Record.',
  ClosingRecordHasBeenApproved: 'Hồ sơ đã được xem xét và không thể hủy bỏ.',
  CancelTheClosingRecord: 'Bạn có chắc chắn muốn hủy đăng ký?',
  AccountClosingRecordCanceled: 'Hồ sơ đóng cửa đã bị hủy',
  CannotBeCancelledAfterApproval: 'Hồ sơ đóng cửa sau khi xét duyệt không thể hủy bỏ, có chắc không?',
  ClosingDateAfterCancelingTheApproval: 'Sau khi hủy bỏ xét duyệt có thể hủy bỏ ngày đóng cửa, được không?',
  BillingType: 'Loại Bill',
  ByTicket: 'Đăng ký',
  InvitationListTip: 'Khách hàng đã gửi bổ sung, mời lại các cặp đơn, sẽ mở khóa trang bổ sung của khách hàng và cho phép gửi lại sau khi chỉnh sửa! Tiếp tục không?',
  PleaseClickFirst: 'Vui lòng nhấp vào "Xác nhận đối chiếu" trước.',
  PleaseSelectTheFeeYouNeedToPush: 'Vui lòng chọn chi phí bạn cần đồng bộ',
  PleaseSelectTheFeeYouNeedToCopy: 'Vui lòng chọn chi phí bạn cần sao chép',
  PleaseSeparateMultipleEmailAddressesWithCommas: 'Nhiều địa chỉ email Vui lòng phân cách bằng dấu phẩy',
  PleaseSupplementOtherMailboxes: 'Vui lòng thêm hộp thư khác',
  ContactAndEmailAreNotMaintained: 'Địa chỉ liên lạc và hộp thư không được duy trì',
  PleaseSelectTheMaintainedContactAndMailbox: 'Vui lòng chọn địa chỉ liên hệ được duy trì cũng như hộp thư',
  SelectMailbox: 'Chọn hộp thư',
  InvoiceUuidCannotBeBlank: 'Hóa đơn uuid không thể để trống',
  TheSettlementUnitIDCannotBeEmpty: 'ID đơn vị thanh toán không được để trống!',
  PleaseEnterYourEmailAddress: 'Vui lòng nhập hộp thư',
  Monthly: 'Nút mặt trăng',
  PleaseSelectTheDataYouWantToExport: 'Vui lòng chọn dữ liệu cần xuất',
  NoData: 'Không có dữ liệu',
  PleaseSelectJob: 'Vui lòng chọn Business.',
  ThisJobIsNotWorkingCanNotBeEdited: 'Danh sách này không hoạt động và không thể được chỉnh sửa.',
  CanNotEditJob: 'Không thể thay đổi công việc!',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: 'Bán hàng và hoạt động giống nhau, xác nhận bạn muốn lưu?',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: 'Loại hàng ôm không giống với hóa đơn nhỏ, có muốn lưu không?',
  WHNoRepeatedContinue: 'Số hiệu vào kho lặp lại, có tiếp tục không?',
  Prompt: 'Mẹo',
  MblNoRepeatedContinue: 'Số MBL lặp lại, bạn có xác nhận lưu không?',
  MblNoRepeatedNotCurrentCompanyContinue: 'Số đơn bạn nhập không thuộc chi nhánh hoặc bộ phận hoạt động của doanh nghiệp hiện tại, vui lòng xác nhận tiếp tục',
  MblNoRepeatedNotCurrentCompanyContinueAll: 'MBL bạn đã nhập trùng lặp và không thuộc chi nhánh hoặc bộ phận hoạt động của doanh nghiệp hiện tại, vui lòng xác nhận tiếp tục',
  MblNoSiRepeatedContinue: 'Số đơn chính lặp lại, có xác nhận lưu không?',
  MblNoRepeatedNotSave: 'MB/L NO.【{0}】 Lặp lại không cho phép lưu.',
  AlreadyAssociatedWithOtherBranches: 'Đã có chi nhánh khác 【{0}】, vui lòng chọn đối tác khác để liên kết!',
  CustomerRefNoRepeatedContinue: 'Số tham chiếu nghiệp vụ lặp lại, có xác nhận lưu không?',
  HblNoRepeatedContinue: 'Số HBL lặp lại, bạn có xác nhận lưu không?',
  SoNoRepeatedContinue: 'Số SoNo lặp lại, có xác nhận lưu không?',
  HAWBRepeatedContinue: 'Số đơn vị HAWB không cho phép lặp lại',
  HBLRepeatedContinue: 'HBL không cho phép lặp lại',
  IATACodeRepeat: 'Mã IATA không thể lặp lại',
  AirCodeRepeat: 'Hãng hàng không không lặp lại',
  AuthenticationFailed: 'Xác nhận thất bại!',
  SaveSuccessfully: 'Lưu thành công',
  InvoiceNoLength: 'Số hóa đơn quá dài, vui lòng kiểm tra',
  Success: 'Thành công',
  ShutOutSuccessfully: 'Thoát quan thành công',
  CancellationSuccessfully: 'Hủy bỏ thành công',
  CancelShutOutSuccessfully: 'Hủy bỏ thành công',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: 'Không thể phân tích mẫu này, xin vui lòng liên hệ với dịch vụ khách hàng.',
  CurrentBranchIsNotSelectedCannotAddNewBookings: 'Không chọn chi nhánh hiện tại và không thể tăng đơn đặt hàng.',
  CompanySelectedIsHQCannotAddNewBookings: 'Công ty lựa chọn làm tổng công ty, không thể tăng thêm đơn đặt hàng.',
  TheLastOfTheNewStateHasBeenRestored: 'Đã khôi phục trạng thái mới lần trước.',
  CancelMotify: 'Hủy sửa đổi hiện tại?',
  Info: 'Thông tin',
  NoBusinessCanBeSplit: 'Không có doanh nghiệp để chia.',
  SplittingErrorContainerInformationIsEmpty: 'Lỗi tách và thông tin đóng gói trống.',
  IsNotOperationStatus: 'Không phải trạng thái hoạt động tích cực.',
  SureDelete: 'Bạn có chắc chắn về Remove?',
  DeleteSuccessfully: 'Xóa thành công',
  CustomerIssuing: 'Khách hàng của HBL không được đánh dấu, vui lòng truy cập trang HBL để đánh dấu.',
  CustomerIssuingTips: 'Trạng thái đặt hàng: Đang chờ nhận/khấu trừ, bạn có tiếp tục tải lên loại tệp "Đơn hàng tự xuất của khách hàng" không?',
  DirectBusiness: 'Đơn thẳng',
  SplittingBusiness: 'Đặt hàng phụ',
  NoPermissionToEditTheJob: 'Bạn không có quyền chỉnh sửa phiếu.',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: 'Các hồ sơ được lựa chọn bao gồm các doanh nghiệp có kiểm toán tài chính, vui lòng kiểm tra.',
  HaveBusinessHasBeenShutOuted: 'Trong hồ sơ được lựa chọn bao gồm có doanh nghiệp hoàn thuế, xin vui lòng kiểm tra.',
  HaveBusinessHasBeenCancellation: 'Các hồ sơ được lựa chọn bao gồm các doanh nghiệp bị hủy bỏ, vui lòng kiểm tra.',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: 'Vui lòng di chuyển vé nhỏ đã chọn từ vé chính và hoàn thuế.',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: 'Vui lòng di chuyển tất cả các vé nhỏ từ vé chính đã chọn và hoàn thuế.',
  HasChargeToShutOutTip: 'Sẽ tiến hành hoàn thuế đối với nghiệp vụ có chi phí, có xác nhận hay không?',
  NoneChargeToShutOutTip: 'Sẽ tiến hành hoàn thuế không phí đối với nghiệp vụ không phí, có xác nhận hay không?',
  BusinessHasBeenSubmittedCannotBeShutOut: 'Nghiệp vụ đã đệ trình xét duyệt tài chính, không thể hoàn quan.',
  NoPermissionToCancelTheShutOut: 'Anh không có quyền hủy bỏ việc đóng cửa.',
  ConfirmToCancelTheShutOut: 'Xác nhận hủy bỏ hoàn quan sao?',
  Warning: 'Cảnh báo',
  NoChargeToShutOut: 'Miễn phí hoàn thuế',
  HasChargeToShutOut: 'Có chi phí hoàn thuế',
  PleaseConfirmTheShutOut: 'Xin xác nhận hoàn quan?',
  SendStatusChangeNotification: 'Gửi thông báo thay đổi trạng thái',
  StatusChangeNotification: 'Thông báo thay đổi trạng thái (Insider)',
  OptionIsChecked: 'Nếu bạn bật tùy chọn này, thư thông báo thay đổi SOP đối nội và đối ngoại sẽ được kích hoạt.',
  OnlyBeUsedForChangingCosts: 'Chỉ có thể thay đổi liên quan đến chi phí',
  DoNotMakeAnyChanges: 'Không thay đổi (tất cả các khoản phí sẽ được xóa)',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: 'Nếu không rõ ràng chi phí đã xác nhận, không thể hoàn quan mà không có chi phí.',
  PleaseRemoveThisTicketFromMblThenShutOut: 'Xin vui lòng di chuyển phiếu nhỏ này ra khỏi vé chính và hoàn thuế.',
  PleaseRemoveAllTicketsFromMblThenShutOut: 'Vui lòng di chuyển tất cả các vé nhỏ từ vé chính này và hoàn thuế.',
  TicketsMustBeVoted: 'Vé nhỏ phải được thêm vào vé chính.',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: 'Chi phí phải trả không thể nộp trước mà không có toàn bộ xét duyệt.',
  CommitSuccessfully: 'Gửi thành công.',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: 'Vé ghép không thể nộp riêng, xin vui lòng nộp vé chính.',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: 'Chi phí có được tạo ra dựa trên giá bán hiện tại, giá mua không?',
  PlatformCodeNotFound: 'Phí vận chuyển hàng không với mã nền tảng A/F không được tìm thấy trong mục phí',
  Withdraw: 'Rút tiền',
  AlreadyReturn: 'Đã trả lại.',
  AlreadyWithdraw: 'Rút lui.',
  ReturnAction: 'Quay lại hoạt động',
  IsConfirm: 'Xác nhận',
  Return: 'Trả lại',
  BatchReturnSucceeded: 'Hoàn trả hàng loạt thành công: {0}',
  BatchReturnPreSubmitCheck: 'Chỉ được phép trả lại các danh sách có trạng thái kinh doanh là đệ trình trước.',
  BatchReturnSubmitCheck: 'Chỉ cho phép rút lại trạng thái kinh doanh là một danh sách đã gửi.',
  BusinessIsNotCommittedAndCannotBeWithdrawn: 'Doanh nghiệp không 【Đã gửi】 trạng thái, không thể rút lại',
  BusinessIsNotPreCommittedAndCannotBeReturn: 'Doanh nghiệp không 【Gửi trước】 trạng thái, không hoàn lại',
  BatchUnlockLockedBillsOfAccountsReceivable: 'Chỉ có thể mở khóa số lượng lớn danh sách chi phí ứng thu đã khóa!',
  lowBalanceTips: 'Bạn xác định rằng số dư tờ khai hải quan không đủ để xác định tất cả các tệp tờ khai tải lên hàng loạt<br/>1) Chọn tiếp tục tải tệp lên lịch sử tệp, nhưng không xác định thông tin tờ khai hải quan<br/>2) Chọn nạp tiền trước khi tải lên, thì tệp không được tải lên theo mặc định và tờ khai hải quan không được giải quyết',
  lowBalanceTips1: 'Tiếp tục upload file',
  lowBalanceTips2: 'Tải lên sau khi nạp tiền.',
  BatchUnlockLockingBillsOfAccountsReceivable: 'Chỉ có thể khóa số lượng lớn danh sách chi phí ứng thu đã mở khóa!',
  BatchUnlockLockingBillsOfAccountsPayable: 'Chỉ có thể khóa hàng loạt danh sách đối phó với chi phí đã mở khóa!',
  BatchUnlockLockedBillsOfAccountsPayable: 'Chỉ có thể mở khóa hàng loạt danh sách đối phó với chi phí bị khóa!',
  UnlockChargeStatus: 'Kiểm tra xem trạng thái phí {0} có được mở khóa không?',
  LockingChargeStatus: 'Kiểm tra xem trạng thái phí {0} có bị khóa không?',
  SuccessfullyUnlockedFeesInBatch: 'Mở khóa hàng loạt {0} Phí thành công: {1}',
  SuccessfullylockingedFeesInBatch: 'Khóa hàng loạt {0} Phí thành công: {1}',
  ThereAreFeesReceivableNotInvoicedPrint: 'Có hóa đơn chưa thu phí, chắc chắn muốn in không?',
  ThereAreFeesReceivableNotInvoicedSubmit: 'Có chi phí chưa lập hóa đơn, chắc chắn phải nộp không?',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'Đơn hàng này sẽ đệ trình xét duyệt tài chính, trước khi đệ trình xin xác nhận tài liệu liên quan đã được tải lên hệ thống, có tiếp tục không?',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'Nghiệp vụ này sẽ đệ trình lên cấp trên xét duyệt, trước khi đệ trình xin xác nhận tài liệu liên quan đã tải lên hệ thống, có tiếp tục hay không?',
  PleaseInputTheSalesInformationAndPrints: 'Vui lòng nhập thông tin nhân viên bán hàng và in lại!',
  PleaseInputTheSalesInformationAndSubmit: 'Vui lòng nhập thông tin nhân viên bán hàng rồi nộp lại!',
  FollowingTheSingleDidNotEnterTheSalesInformation: 'Các đơn hàng sau đây không nhập thông tin nhân viên bán hàng',
  PleaseEnterAndPrint: 'Vui lòng nhập trước khi in!',
  PleaseSelectAWaterBillRecord: 'Vui lòng chọn Hồ sơ nước.',
  PleaseEnterAndSubmit: 'Vui lòng nhập trước khi gửi!',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: 'Có chi phí nước ngoài không có số hóa đơn hợp lệ, không thể in bảng phân tích lợi nhuận!',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: 'Có chi phí nước ngoài không có số hóa đơn hữu hiệu, không thể đệ trình!',
  BulkSubmissionOfWrittenSubmissionsOnlyList: 'Chỉ có thể đệ trình danh sách đã đệ trình trước với số lượng lớn!',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: 'Chỉ có thể lấy trước danh sách trạng thái thao tác chính với số lượng lớn!',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: 'Hãy chắc chắn rằng bạn muốn điều này',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: 'Danh sách vé có nộp xét duyệt tài chính không?',
  BatchSubmittedSuccessfully: 'Gửi hàng loạt thành công',
  BatchSubmittedPreSuccessfully: 'Pre-Submission thành công',
  TheSelectedDocumentInconsistentNatureOfTheBooking: 'Tài liệu được chọn có tính chất không phù hợp',
  TheSelectedDocumentIsNotTheSameVoyage: 'Tài liệu được chọn không phải là cùng một chuyến đi/tên tàu',
  SelectTheData: 'Vui lòng chọn dữ liệu',
  NoSelectedDataOrAreNotOperationalStatus: 'Dữ liệu không được chọn hoặc không hoạt động tích cực',
  TheSelectedServicesIncludeLockedServices: 'Các doanh nghiệp được chọn có doanh nghiệp bị khóa',
  SureYouWantToRemoveTheCharge: 'Bạn có chắc chắn muốn loại bỏ chi phí?',
  NoCostToRemove: 'Không có chi phí để loại bỏ.',
  NoBusinessOrIsNotOperationalState: 'Không có doanh nghiệp hoặc trạng thái hoạt động tích cực được chọn.',
  MakeSureToDelegateTheBusiness: 'Bạn có chắc chắn muốn ủy thác kinh doanh vé này?',
  ErrorReadingInformation: 'Đọc thông tin bị lỗi.',
  OrderTypeChangeTip: 'Sau khi chuyển đổi loại đơn đặt hàng, một phần dữ liệu đã điền sẽ bị xóa, bạn có xác nhận chuyển đổi không?',
  BusinessDateCanNotNull: 'Ngày kinh doanh không được để trống',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: 'Người nhận không duy trì thông tin công ty hiện tại trong Đối tác',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: 'Doanh nghiệp bút đã gửi ủy quyền điện tử, nó có được gửi lại không?',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: 'Không tìm thấy kiểu mẫu tương ứng 【BOOKING】 và tên mẫu 【Giấy ủy quyền vận chuyển hàng hóa xuất khẩu bằng đường biển】, bạn có muốn tiếp tục ủy quyền không?',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'Chi nhánh của đại lý đặt chỗ hiện tại không duy trì đối tác tương ứng với công ty trong số các đối tác',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'Chi nhánh của đại lý vận chuyển hiện tại không duy trì đối tác tương ứng với công ty trong số các đối tác',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: 'Chi nhánh của đại lý cảng đích hiện tại không duy trì đối tác tương ứng với công ty trong số các đối tác',
  TheBranchCompanyOfUnExchangeAgent: 'Chi nhánh của đại lý thay đổi hiện tại không duy trì đối tác tương ứng với công ty trong số các đối tác',
  TheBranchCompanyOfUnOurCompany: 'Chi nhánh hiện tại của công ty vận tải không duy trì đối tác tương ứng với công ty trong số các đối tác',
  TheOppositeSideHasScceptedNoNeedToReCommission: 'Đối phương đã thụ lý, không cần ủy thác lần nữa!',
  SuccessfullySent: 'Gửi thành công.',
  NoSendingGoodsInfo: 'Không có thông tin hàng hóa cần gửi',
  NoAssociatedBusiness: 'Không có doanh nghiệp liên kết!',
  NoAssociatedContainerInfo: 'Không có thông tin đóng gói để gửi',
  PleaseEnterFleetInformatio: 'Vui lòng nhập thông tin đoàn xe',
  ThisBoxIsNotAllowedToBeDeleted: 'Hộp này không được phép gỡ bỏ',
  FailedToQueryTheAssociatedBusiness: 'Không tìm thấy liên kết kinh doanh.',
  RepeatedWarehouseNo: 'Số lượng repeat',
  NoStorageInfo: 'Không có thông tin nhập kho',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: 'Danh sách công việc không chính xác, vui lòng làm mới lại trang hoặc liên hệ với quản trị viên!',
  ConsignationCompanyCannotBeNull: 'Đơn vị ủy quyền không được để trống',
  FLCLTypeCannotBeNull: 'Kiểu đánh vần đầy đủ không được để trống',
  POLCannotBeNull: 'Cảng khởi hành không được để trống',
  IfThereIsATransferTheTransferPortCannotBeNull: 'Cảng trung chuyển không thể để trống nếu có quá cảnh',
  PortOfDischargeCannotBeNull: 'Cảng hàng không được để trống',
  PortOfDestinationCannotBeNull: 'Cảng đích không được để trống',
  SalesCannotBeNull: 'Bán hàng không được để trống',
  SalesBranchCompanyIsNullPleaseReSelectSales: 'Chi nhánh bán hàng đang trống, vui lòng chọn lại Bán hàng!',
  SalesDepartmentIsNullPleaseReSelectSales: 'Vui lòng chọn bộ phận bán hàng!',
  DateOfDepartureCannotBeLaterThanDateOfArrival: 'Ngày khởi hành không thể muộn hơn ngày đến cảng',
  NominatedAgentCannotBeNull: 'Đại lý chỉ định không thể để trống!',
  FLCLTypeCannotBeNull2: 'Loại lắp ráp không thể để trống!',
  ItemNoCannotBeNull: 'Số mục không được để trống!',
  EQSizeCannotBeNull: 'Hộp không thể rỗng!',
  EQSizeCannotBeNull2: 'Có ít nhất một hộp!',
  DearYouCanOnlySelectYourOwnCustomers: 'Anh chỉ có thể chọn khách hàng của mình thôi.',
  DepartmentCannotBeNull: 'Bộ phận không thể để trống.',
  CyCutoffDateCannotBeLaterThanDepartureDate: 'Ngày đóng cửa không được lớn hơn ngày khởi hành',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: 'Ngày đóng sà lan không được lớn hơn ngày đóng!',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: 'Thông tin niêm phong hộp liên quan đã được nhập và không thể xóa.',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: 'Các thông tin cài đặt liên quan đã được nhập vào, không thể xóa.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: 'Trọng lượng tính phí thay đổi, có đổi mới chi phí vốn có theo trọng lượng tính phí không? Chi phí đã làm hóa đơn, lập hóa đơn sẽ không được cập nhật.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: 'Trọng lượng tính phí thay đổi, có đổi mới chi phí vốn có theo trọng lượng tính phí không? Chi phí đã được thực hiện hóa đơn, hóa đơn, yêu cầu thanh toán, bán hàng sẽ không được cập nhật',
  CurrencyChangeConfirm: 'Loại tiền giá mua/giá bán đã thay đổi. Làm mới chi phí hiện có? Chi phí đã lập hóa đơn, xuất hóa đơn, yêu cầu thanh toán hoặc đã thanh lý sẽ không được cập nhật',
  PriceUpdateConfirm: 'Giá mua/giá bán đã thay đổi. Xác nhận có cập nhật chi phí dựa trên trọng lượng tính phí mỗi đơn vị cho giá mua và giá bán không? Chi phí đã lập hóa đơn, phát hành hóa đơn, đăng ký thanh toán và ghi nợ đã được xử lý sẽ không được cập nhật',
  PriceTypeChangeConfirm: 'Loại giá mua/giá bán đã thay đổi. Làm mới chi phí hiện có? Chi phí đã lập hóa đơn, xuất hóa đơn, yêu cầu thanh toán hoặc đã thanh lý sẽ không được cập nhật',
  TheChargedWeightHasBeenChanged: 'Trọng lượng tính phí thay đổi, có đổi mới chi phí vốn có theo trọng lượng tính phí không?',
  WeightChangeToRefreshCostBasedOnWeightPrice: 'Trọng lượng phát sinh thay đổi, có đổi mới chi phí vốn có theo giá trọng lượng làm đơn vị hay không? Chi phí đã thực hiện hóa đơn, lập hóa đơn, yêu cầu thanh toán, bán hàng, vận đơn liên kết sẽ không được cập nhật',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: 'Thay đổi trọng lượng, có đổi mới chi phí vốn có theo giá trọng lượng (tấn) không? Chi phí đã thực hiện hóa đơn, lập hóa đơn, yêu cầu thanh toán, bán hàng, vận đơn liên kết sẽ không được cập nhật',
  CubageChangeToRefreshCostBasedOnCubagePrice: 'Thay đổi thể tích, có đổi mới chi phí vốn có theo giá thể tích là đơn vị không? Chi phí đã thực hiện hóa đơn, lập hóa đơn, yêu cầu thanh toán, bán hàng, vận đơn liên kết sẽ không được cập nhật',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: 'Số lượng linh kiện nhỏ xảy ra thay đổi, có đổi mới chi phí vốn có theo giá trị của các linh kiện nhỏ không? Chi phí đã thực hiện hóa đơn, lập hóa đơn, yêu cầu thanh toán, bán hàng, vận đơn liên kết sẽ không được cập nhật',
  ChangeToRefreshCostBasedOnCubagePrice: 'Số lượng mảnh nhỏ, tổng trọng lượng, khối lượng, trọng lượng thanh toán thay đổi, làm mới ban đầu theo số lượng mảnh nhỏ, giá trọng lượng, giá khối lượng, giá trọng lượng thanh toán cho đơn vị chi phí? Chi phí đã thực hiện hóa đơn, lập hóa đơn, yêu cầu thanh toán, bán hàng, vận đơn liên kết sẽ không được cập nhật',
  DistributedSuccessfully: 'Giao hàng thành công',
  BusinessReferenceNoReduplicated: 'Số tham chiếu doanh nghiệp lặp lại',
  BookingAgentCannotBeNull: 'Đại lý đặt phòng không được để trống',
  DateOfDepartureCannotBeNull: 'Ngày khởi hành không được để trống',
  TheMainInterfaceDoesNotExist: 'Giao diện chính không tồn tại',
  FeesHaveBeenUsedForThisUnit: 'Đã có chi phí sử dụng đến đơn vị này, xin điều chỉnh đơn vị chi phí liên quan trước rồi mới xóa bỏ!',
  TheChargingUnitIsUsedByAnExistingChargePlan: 'Đơn vị tính phí đã được sử dụng, vui lòng điều chỉnh đơn vị tính phí trước khi xóa.',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: 'Số hiệu nghiệp vụ chính chưa được tạo ra, xin hãy lưu vé chính trước.',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: 'Hóa đơn này đã được ghép lại, không thể chuyển ra.',
  PleaseSelectSubBills: 'Vui lòng chọn vé nhỏ.',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: 'Vui lòng lưu dữ liệu đã thay đổi hoặc thoát khỏi trạng thái chỉnh sửa, sau đó đóng mô-đun.',
  MblNoIsNull: 'MB/L Không rỗng',
  SONoIsNull: 'S/O Không rỗng',
  NoVesselVoyageInformation: 'Không có thông tin tên tàu',
  ObtainSuccessfully: 'Nhận thành công',
  PleaseSelectCopyType: 'Vui lòng chọn loại bản sao.',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: 'Không tìm thấy công ty tàu này, vui lòng làm mới bộ nhớ cache!',
  BlIsConfirmed: 'Vận đơn đã được xác nhận.',
  ThisHblIsCombinedAndCannotBeEdited1: 'Vé HBL đã được đưa vào',
  ThisHblIsCombinedAndCannotBeEdited2: 'Không thể chỉnh sửa.',
  ToOrederBlCannotBeTelexReleased: 'To order Không thể phóng điện',
  PleaseInputBlSerialNumberFirst: 'Vui lòng nhập số dòng chảy vận đơn trước!',
  PleaseSelectTheListToBeMergedInto: 'Vui lòng chọn danh sách cần nhập!',
  PleaseInputBussinessNo: 'Vui lòng nhập số doanh nghiệp!',
  NoSelectedContainerInformation: 'Thông tin đóng gói không được đánh dấu.',
  PleaseSelectData: 'Vui lòng kiểm tra dữ liệu',
  OnlySelectOneData: 'Chỉ có thể chọn một dữ liệu',
  Count: 'Số phiếu',
  AreYouSureYouWantToRemoveTheSubBill: 'Xác nhận muốn chuyển hóa đơn không?',
  RemovedSuccesfully: 'Xóa thành công',
  NoSubBillsToSplit: 'Không có phiếu chia nhỏ.',
  SoNoCannotBeNull: 'Số đóng (S/O) không được để trống.',
  CancelTheCurrentQuery: 'Hủy yêu cầu hiện tại?',
  SelectTheOrderYouWantToJoin: 'Vui lòng chọn đơn đặt hàng để tham gia.',
  HasJoinIntoMbl: 'Đã thêm vào phiếu chính.',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: 'Tên tàu, chuyến bay, người vận chuyển, đại lý đặt khoang, đại lý cảng đích, ETD、ETA、 Thông tin kho hàng không phù hợp với vé chính. Hệ thống sẽ thay đổi hóa đơn nhỏ. Tiếp tục không?',
  ContainerNoDoesNotComplyWithTheNumberingRules: 'Số hộp không phù hợp với quy tắc số.',
  SealNoHasBeenChanged: 'Số niêm phong đã được thay đổi.',
  PleaseSelectTheDesiredPrintVgm: 'Vui lòng chọn VGM cần in.',
  DeleteTheVgmInformation: 'Bạn có muốn xóa thông tin VGM này không?',
  PleaseEnterEnglish: 'Vui lòng nhập tiếng Anh.',
  PleaseEnterTheShippingCompanyInformation: 'Có chi phí vận chuyển, vui lòng nhập thông tin công ty vận chuyển!',
  SameJobtruckOrderNo: 'Số xe đóng thùng ở cửa đối diện tồn tại lặp lại, xin sửa lại!',
  SureYouRemoveThisNData1: 'Hãy chắc chắn để loại bỏ điều này',
  SureYouRemoveThisNData2: 'Dữ liệu?',
  AreYouSureYouWantToSendACarOrder: 'Bạn có chắc chắn muốn gửi đơn đặt hàng?',
  AreYouSureYouWantToModifyACarOrder: 'Bạn có chắc chắn muốn thay đổi danh sách giao hàng?',
  AreYouSureYouWantToRevokeACarOrder: 'Bạn có chắc chắn muốn rút lui?',
  ThisCarOrderIsSended: 'Sau khi gửi đơn thành công, không thể gửi đơn lần nữa, chỉ có thể thông qua sửa đơn tiến hành yêu cầu sửa chữa.',
  ThisCarOrderCanOnlyBeModifiedAfterSending: 'Sau khi giao đơn mới có thể tiến hành thao tác sửa đơn.',
  ThisCarOrderIsSendedNoAddUsage: 'Sau khi một phiếu phái xe phái xe thành công, không cho phép thêm tủ nữa.',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: 'Chỉ có trạng thái bỏ lỡ mới có thể rút đơn hàng.',
  ThisCarOrderIsChanged: 'Lưu ý: Thay đổi dữ liệu trả về',
  DeleteFailed: 'Lỗi xóa',
  Failure: 'Thất bại',
  DispatchSuccess: 'Đặt hàng thành công',
  ModifiedTruckOrderSuccess: 'Thay đổi thành công',
  RevokeTruckOrderSuccess: 'Rút lệnh thành công',
  DispatchFailed: 'Có gì đó bất thường.',
  ModefiedTruckOrderFaild: 'Thay đổi bất thường',
  RevokeTruckOrderFaild: 'Có gì đó bất thường về lệnh rút lui.',
  VgmWeightingMethod: 'Phương pháp cân VGM',
  LdpWarn: 'Đối với hàng đông lạnh, cần có ít nhất một dòng điền cùng lúc',
  WxpWarn: 'Đối với hàng nguy hiểm, cần có ít nhất một dòng điền cùng lúc',
  Transfer: 'Thay tàu của đại lý',
  ReasonForDeletion: 'Lý do xóa',
  ReasonForDeletionNotEmpty: 'Lý do xóa không được để trống',
  VesselRegex: 'Chữ cái và số, tối đa 35 ký tự',
  BlNumberRegex: 'Chỉ cho phép số',
  DanClass: 'Phải từ 1 đến 9,9',
  CubageRegex: 'Phạm vi từ 0,001 đến 2000,999',
  RowPrefix: 'Số tờ khai {0}',
  UpdateVesselVoyNo: 'Sửa tên tàu và chuyến',
  UpdateVesselVoyNoError: 'Không thể sửa tên tàu chuyến cho manifest chưa gửi',
  InputVesselVoyNo: 'Vui lòng nhập tên tàu chuyến đã cập nhật',
  ShipNotRegistered: 'Tàu chưa đăng ký',
  LoadManifest: 'Tải manifest',
  ModificationFailed2: 'Đổi phân bố thất bại',
  ModifiedSuccessfully: 'Đổi phân bố thành công',
  NoDelete: 'Không có dữ liệu để gửi xóa manifest',
  SendFailed: 'Gửi thất bại',
  SaveFailed: 'Lỗi lưu',
  ViewWarehouseEntryPhotos: 'Xem ảnh vào kho',
  DistributeFailedNoFoundRelatedStorageRecord: 'Giao hàng thất bại, không tìm được ghi chép kho hàng tương ứng!',
  SureYouWantToCancelTheBindingToTheStorageData: 'Xác nhận bạn muốn gỡ bỏ ràng buộc với dữ liệu kho?',
  QueryFailed: 'Truy vấn không thành công',
  SelectDeclarations: 'Vui lòng chọn tờ khai hải quan.',
  SelectCustomsInformation: 'Vui lòng chọn thông tin hải quan.',
  SelectCustomsRecord: 'Vui lòng chọn tờ khai hải quan.',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: 'Ồ, bạn đã nhập không đủ 10 chữ số.',
  OperatingCompanyCannotBeNull: 'Đơn vị kinh doanh không được để trống.',
  DateOfCustomsDeclarationCannotBeNull: 'Ngày khai hải quan không được để trống.',
  PleaseSelectStatusOfCustomsDeclaration: 'Vui lòng chọn trạng thái khai báo hải quan.',
  CargoDetailsWEIGHTBannotBeNull: 'Chi tiết sản phẩm - WEIGHT không được để trống',
  CargoDetailsAMOUNTBannotBeNull: 'Chi tiết sản phẩm - Amount không được để trống',
  CargoDetailsCustomsDutyRateBannotBeNull: 'Chi tiết hàng hóa - thuế suất thuế quan không thể để trống',
  CargoDetailsCustomsDutiesBannotBeNull: 'Chi tiết hàng hóa - thuế quan không thể để trống',
  CargoDetailsIncrementRateCannotBeNull: 'Chi tiết hàng hóa - thuế suất VAT không thể để trống',
  CargoDetailsIncrementValueDutyBannotBeNull: 'Chi tiết hàng hóa - VAT không được để trống',
  CargoDetailsConsumptionDutyRateBannotBeNull: 'Chi tiết hàng hóa - thuế suất GST không thể để trống',
  CargoDetailsConsumptionDutyBannotBeNull: 'Chi tiết hàng hóa - GST không thể để trống',
  CargoDetailsCurrencyBannotBeNull: 'Chi tiết hàng hóa - đồng tiền không được để trống',
  CargoDetailsExchangeBannotBeNull: 'Chi tiết hàng hóa - tỷ giá hối đoái không thể để trống',
  CargoDetailsCargoPriceBannotBeNull: 'Chi tiết hàng hóa - giá hàng không được để trống',
  CargoDetailsTaxBannotBeNull: 'Chi tiết hàng hóa - thuế không được để trống',
  CargoDetailsTaxRateBannotBeNull: 'Chi tiết hàng hóa - thuế suất không được để trống',
  ImportSuccessful1: 'Nhập thành công',
  ImportSuccessful2: 'Thanh',
  ImportFailed: 'Nhập thất bại',
  CargoDetailsIsNotSelected: 'Chưa chọn chi tiết hàng hóa.',
  PleaseSelectUnRelatedTradeDetailData: 'Vui lòng chọn thông tin hàng hóa không liên quan',
  SelectTheBillingObject: 'Chọn đối tượng thanh toán',
  NoChargeForTheSettlementOfDomesticObjects: 'Không có chi phí cho đối tượng thanh toán trong nước.',
  CancelAudit: 'Hủy kiểm toán',
  ChargesAudit: 'Kiểm toán chi phí',
  ThereAreFeesCantBeDeletedPleaseRecheck: 'Đã bao gồm các khoản phí không thể xóa, vui lòng kiểm tra lại.',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: 'Chi phí đã được thanh toán tài chính, không thể sửa đổi.',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: 'Chi phí xung đỏ hoặc chi phí xung đỏ không thể điều chỉnh lại, xin vui lòng chọn điều chỉnh thêm.',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: 'Chi phí xung đỏ hoặc chi phí xung đỏ không thể bị xóa, xin vui lòng chọn lại.',
  PleaseRefresh: 'Chi phí đã được sửa đổi bởi người khác, vui lòng làm mới',
  ChargeItemCannotBeNull: 'Tên chi phí không được để trống!',
  MeasureCannotBeNull: 'Đơn vị chi phí không thể để trống!',
  SettlementPartyCannotBeNull: 'Đối tượng thanh toán không thể để trống!',
  CurrencyCannotBeNull: 'Tiền chủng không thể vì không!',
  AmountCannotBeNull: 'Số lượng không thể để trống!',
  UnitRateCannotBeNull: 'Đơn giá không thể để trống!',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: 'Dịch vụ khai hải quan không được đánh dấu và không thể thêm:',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: 'Dịch vụ kho bãi không được đánh dấu và không thể được thêm vào:',
  HaulageServiceIsNotSelectedInBookingCannotAdd: 'Dịch vụ vận chuyển không được đánh dấu và không thể thêm:',
  ChargeIsNotSelectedOrAllChargesSubmit: 'Không có khoản phí nào được chọn hoặc tất cả đã được nộp.',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: 'Không có phí hoặc trạng thái nộp được chọn.',
  OperationSuccessfully: 'Hoạt động thành công',
  PayablesIsNull: 'Chi phí là trống.',
  ReceivalbeIsNull: 'Phải thu phí là trống.',
  CopyThePayablesSuccessfullyTotallyOfNItems1: 'Sao chép chi phí phải trả thành công, đồng sản xuất',
  CopyThePayablesSuccessfullyTotallyOfNItems2: 'Chi phí bút',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: 'Sao chép phải thu phí thành công, đồng sản xuất',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: 'Chi phí bút',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: 'Không có chi phí phải trả để sao chép và cùng một tên chi phí có thể tồn tại.',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: 'Không có chi phí phải thu để sao chép và cùng một tên chi phí có thể tồn tại.',
  CopyChargeSuccessfullyTotallyOfNItems1: 'Chi phí sao chép thành công, đồng sản xuất',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: 'Không có chi phí để sao chép và cùng một tên chi phí có thể tồn tại.',
  TheCurrentlyRelevantBusinessInformationIsNull: 'Thông tin doanh nghiệp liên quan hiện tại là trống.',
  PleaseSelectCharges: 'Vui lòng chọn phí',
  SelectChargesAreInControl: 'Kiểm soát chi phí lựa chọn',
  SelectedChargesAreCancelledControlling: 'Bỏ kiểm soát phí lựa chọn',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: 'Vui lòng kiểm tra chi tiết giá vận chuyển!',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: 'Vui lòng kiểm tra chi tiết giá vận chuyển hàng không!',
  DoYouNeedToInviteOthersToConfirmTheCharges: 'Bạn có cần một lời mời để xác nhận chi phí?',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: 'Email đã được gửi, hãy chú ý đến yêu cầu!',
  PleaseSelectReceivableCharges: 'Vui lòng chọn một khoản phí phải thu',
  PleaseSelectPayableCharges: 'Vui lòng chọn một khoản phí phải trả',
  OnlyAuditChargesHaveBeenSubmitted: 'Chỉ có thể xem xét các khoản phí đã nộp',
  NoChargesToAudit: 'Không có chi phí để xem xét, hãy kiểm tra người đánh giá chi phí hoặc trạng thái chi phí',
  NoChargesToUnAudit: 'Không có chi phí hủy bỏ đánh giá, hãy kiểm tra người đánh giá chi phí hoặc trạng thái chi phí',
  NoChargesToReject: 'Không có phí để từ chối, hãy kiểm tra người đánh giá phí hoặc trạng thái phí',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: 'Hãy chắc chắn rằng bạn là người đánh giá tất cả các chi phí',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: 'Chi phí bao gồm toàn bộ việc phân phối hạt nhân trong chi phí đã chọn, có được thêm vào hóa đơn không?',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: 'Tất cả các khoản phí đã chọn đều được bán hết, vui lòng chọn lại',
  IncludeFullyWrittenOffCosts: 'Chi phí đã chọn bao gồm các khoản đã thanh lý toàn bộ. Thêm vào hóa đơn không?',
  AuditSuccessfully: 'Kiểm toán thành công',
  CancelSuccessfully: 'Hủy bỏ thành công',
  PleaseSelect1ChargeDetail: 'Vui lòng chọn chi tiết chi phí.',
  NoPriceToMeetTheQueryCriteria: 'Không tìm thấy giá phù hợp.',
  Prepaid: 'Trả trước',
  Collect: 'Trả tiền',
  PrePayTheSamePrice: 'Trả trước cùng giá',
  RefreshRateFailed: 'Đổi mới giá vận chuyển thất bại!',
  PleaseSelectThePrice: 'Vui lòng chọn giá!',
  Invalidation: 'Mất hiệu lực',
  Normal: 'Bình thường',
  suspension: 'Dừng tàu',
  NoPickingUp: 'Không nhận',
  Inquiry: 'Yêu cầu',
  Tension: 'Căng thẳng',
  OverStowage: 'Buồng nổ',
  CreateBill: 'Xây dựng hóa đơn theo từng loại tiền tệ',
  SplitBill: 'Đừng chia tiền ra để tạo hóa đơn.',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: 'Xin chú ý giá vận chuyển đang trong trạng thái ngừng bay!',
  PleaseBeNotedThatThisRateIsUnavailableNow: 'Xin chú ý giá vận chuyển đang trong trạng thái không tiếp nhận!',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: 'Xin lưu ý rằng phần giá vận chuyển này không nhận được!',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: 'Xin chú ý giá vận chuyển đang trong trạng thái bùng nổ!',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: 'Chọn giá Vận chuyển từ nguồn khác với đại lý đặt hàng của đơn đặt hàng',
  Unconfirmed: 'Không xác nhận',
  Confirmed: 'Xác nhận',
  Receivable: 'Phải nhận',
  Payable: 'Đối phó',
  Bill: 'Thanh toán',
  TheBillDoesNotConfirm: 'Hóa đơn không được xác nhận',
  SureYouWantToCancel: 'Bạn chắc chắn muốn hủy bỏ?',
  StateModifiedSuccessfully: 'Thay đổi trạng thái thành công.',
  NoInternalCostsToBilling: 'Không có chi phí trong nước để lập hóa đơn',
  NoSettlementUnit: 'Không có đơn vị thanh toán.',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: 'Đối tượng thanh toán là trống, không thể xác nhận chi phí mới.',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: 'Thông tin về các đối tượng thanh toán không được đọc thành công.',
  YouDontHavePermissionToEditBills: 'Bạn không có quyền chỉnh sửa các hóa đơn phải trả.',
  YouDontHavePermissionToDeleteBills: 'Bạn không có quyền xóa các hóa đơn phải trả.',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: 'Không có quyền xóa các hóa đơn do người dùng khác tạo ra',
  NoSelectedBill: 'Chưa chọn hóa đơn.',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: 'Đối tượng thanh toán không tồn tại, xin hãy đặt lại bộ nhớ cache thử xem.',
  BillSaveSuccessfully: 'Tiết kiệm hóa đơn thành công',
  BillingObjectIsNull: 'Hóa đơn trống rỗng.',
  ChargeCannotBeEmpty: 'Chi phí không được để trống.',
  TaxesAndTaxRatesDoesNotMatchTheData: 'Số liệu thuế suất và thuế suất không phù hợp.',
  InvoicingHeadCannotBeEmpty: 'Hóa đơn không thể để trống',
  CurrencyExchangeRateIsNotMaintained1: 'Tiền tệ',
  CurrencyExchangeRateIsNotMaintained2: 'Tỷ giá hối đoái không được duy trì.',
  FeeCurrencyMustBeTheSame: 'Chi phí phải giống nhau.',
  NoForeignFeeBilling: 'Không có chi phí nước ngoài để thanh toán.',
  ThisJobIsNotWorkingCanNotBeDeleted: 'Danh sách này không phải trạng thái vận hành dương, không thể xóa bỏ.',
  SureYouWantToDeleteTheBilling: 'Bạn có chắc chắn để xóa hóa đơn này?',
  SureAuditTheBill: 'Bạn có chắc chắn về việc xem xét hóa đơn này?',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: 'Hóa đơn này đã được nộp để xem xét tài chính và không thể bị hủy bỏ.',
  ThisOrderHasBeenRevokedNotARepeatedAction: 'Danh sách này đã bị hủy và không thể lặp lại.',
  DomesticBillsCannotBeVoided: 'Hóa đơn nội địa không thể hủy bỏ',
  TheBillHasBeenConfirmedAndCannotBeVoided: 'Hóa đơn đã được xác nhận, không thể hủy bỏ<br/>Nếu cần hủy bỏ, vui lòng hủy xác nhận trước',
  ThisVerificationHasBeenDoneAndCannotBeVoided: 'Đơn hàng này đã được bán hạt nhân, không thể bị hủy bỏ.',
  AccountIsClosedAnyOperationIsNotAllowed: 'Đã đóng tài khoản, không cho phép hoạt động.',
  ThisFormIsLockedAndCannotBeVoided: 'Danh sách này đã bị khóa và không thể bị hủy bỏ.',
  ThisFormIsLockedAndBillingGroup: 'Bản sao kê này tồn tại và không thể bị hủy bỏ.',
  ConfirmTheCancellationOfTheBill: 'Xác định hủy bỏ hóa đơn?',
  ConfirmTheCancellationOfTheBill2: 'Xác nhận hủy bỏ hóa đơn đã chọn?',
  TheBillHasBeenRevoked: 'Hóa đơn đã hết hiệu lực.',
  NoSelectSettlement: 'Đối tượng thanh toán không được chọn.',
  BillOfExchangeCannotBeEmpty: 'Tỷ giá hối đoái không được để trống',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: 'Thanh toán hộ và chi phí thông thường không thể kết hợp với nhau để lập hóa đơn.',
  TheBillNumberIsCreatedSuccessfully: 'Số hóa đơn tạo thành công',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: 'Tên hoặc mã hai chữ quản lý mạng tương ứng với đại lý nước ngoài chưa được duy trì, không thể tạo ra số hóa đơn!',
  EnterTheShareProportion: 'Vui lòng nhập tỷ lệ chia.',
  PleaseSelectACurrency: 'Vui lòng chọn đồng tiền.',
  PleaseEnterTheBillingObject: 'Vui lòng nhập đối tượng thanh toán.',
  PleaseAddCosts: 'Vui lòng thêm phí.',
  TheAmountOfBillCannotBeEqualTo: 'Số tiền thanh toán không thể bằng 0',
  PleaseEnterTheNameOfTheCosts: 'Vui lòng nhập tên chi phí.',
  PleaseEnterTheQuantityOfTheCosts: 'Vui lòng nhập số lượng phí.',
  PleaseEnterThePriceOfTheCosts: 'Vui lòng nhập đơn giá.',
  PleaseSelectTheCostToRemove: 'Vui lòng chọn mức phí cần xóa.',
  CollectingInconsistentWithTheTotalAdvance: 'Thu hộ và ứng trước không nhất trí!',
  TheBillHasBeenInvoicedAndCannotBeDeleted: 'Hóa đơn đã được lập hóa đơn và không thể xóa',
  LoadFailed: 'Tải không thành công',
  PlatformCodeAlreadyExists: 'Mã nền tảng đã tồn tại!',
  NameCannotBeRepeated: 'Không được lặp lại tên tiếng Trung hoặc tiếng Anh của các đối tượng được trả tiền!!!',
  ChineseNameCannotBeBlank: 'Tên Trung Quốc của các đối tượng thu phí không được để trống!!!',
  CannotBeModified: 'Đã được doanh nghiệp sử dụng và không thể thay đổi tên',
  PleaseSelectAServiceItem: 'Vui lòng chọn mục dịch vụ',
  Overseas: 'Nước ngoài',
  Domestic: 'Nội địa',
  PleaseSelectTheDesiredPrintInformation: 'Vui lòng chọn thông tin cần in',
  ThereIsAnErrorReadingWriteOffInformation: 'Lỗi đọc thông tin hóa đơn hạt nhân',
  TheBookingDoesNotExistAndCannotBeAdded: 'Đơn đặt hàng không tồn tại và không thể được thêm vào.',
  PleaseEnter: 'Bắt đầu truy vấn sau khi nhập ít nhất hai ký tự',
  PleaseEnterTheCode: 'Vui lòng nhập các truy vấn mờ như mã, tên...',
  PleaseEnterTheCode2: 'Vui lòng nhập (ít nhất hai ký tự) mã, tên và các truy vấn mờ khác...',
  PleaseEnterTheContent: 'Vui lòng nhập nội dung',
  PleaseSelectDataBeforeOperation: 'Vui lòng chọn hành động sau dữ liệu',
  NoPortRecordMeeting: 'Không có hồ sơ cảng nào đáp ứng yêu cầu được chọn, vui lòng chọn lại!',
  DeleteTheSelectedRecord: 'Có xóa bản ghi đã chọn hay không',
  DoYouConfirmThatYouWantToDelete: 'Bạn có chắc chắn rằng bạn muốn xóa nó?',
  DeletionCancelled: 'Đã gỡ bỏ',
  EditCancelled: 'Hủy chỉnh sửa',
  PleaseSelectARecordToEdit: 'Vui lòng chọn một bản ghi để chỉnh sửa',
  PleaseFillInTheCorrectFiveDigitPortCode: 'Vui lòng điền đúng mã số 5 cổng.',
  DeleteFail: 'Xóa thất bại!',
  DeleteSucceeded: 'Xóa thành công!',
  DisplayRuleCannotBeEmpty: 'Quy tắc hiển thị không được để trống!',
  OperationRequirementsCannotBeEmpty: 'Yêu cầu thao tác không được để trống!',
  OperationRequirementsCannotBeGreaterThan: 'Độ dài yêu cầu hoạt động không được lớn hơn 2048 bit!',
  NewPortRequestSucceeded: 'Cảng mới yêu cầu thành công',
  EditPortRequestSucceeded: 'Sửa đổi yêu cầu cảng thành công',
  ConfirmDelete: 'Xóa xác nhận',
  IsItUsedForMAWB: 'Dùng cho MAWB',
  IsItUsedForHAWB: 'Dùng cho HAWB',
  AddPortRequirementsAirport: 'Thêm yêu cầu cảng (cảng hàng không)',
  EditPortRequirementsAirport: 'Chỉnh sửa yêu cầu cảng (cảng hàng không)',
  PleaseSelectARecordToDelete: 'Vui lòng chọn bản ghi để xóa',
  BackPageTip: '【Quay lại trang trước】 sẽ xóa thông tin đã điền trên trang bảo hiểm để xác nhận rằng bạn muốn quay lại?',
  WarmReminder: 'Gợi ý ấm áp',
  GoBack: 'Quay lại trang trước',
  ReturnToHomepage: 'Quay lại trang đầu',
  HomepageNotSupportImport: 'Bảo hiểm hàng hóa không hỗ trợ nhập khẩu trực tiếp',
  PortInformationEditedSuccessfully: 'Thông tin cảng thành công',
  AirlineInformationEditedSuccessfully: 'Thông tin hãng hàng không thành công',
  SuccessfullyAddedAirlineInformation: 'Thêm thông tin hãng hàng không thành công',
  SuccessfullyAddedPortInformation: 'Thêm thông tin cảng thành công',
  GetBack: 'Lấy lại',
  FailedToInquiryCustomsDeclarationInformation: 'Truy vấn thông tin khai hải quan thất bại:',
  PleaseSelectARecord: 'Vui lòng chọn Record.',
  NewDocuments: 'Giấy tờ mới',
  EditDocuments: 'Sửa tài liệu',
  FileTypeCannotBeEmpty: 'Loại tập tin không thể để trống!',
  FileNumberCannotBeEmpty: 'Số tập tin không được để trống',
  FileNumberAlreadyExists: 'Số tập tin đã tồn tại.',
  DataEnabledSuccessfully: 'Dữ liệu được kích hoạt thành công.',
  DataDisabledSuccessfully: 'Vô hiệu hóa dữ liệu thành công.',
  Error2: 'Lỗi',
  TheDocumentHasBeenSaved: 'Chứng từ đã được lưu.',
  TheCustomsBrokerCannotBeEmpty: 'Cửa hàng hải quan không được để trống.',
  NoInformationCanBeQueried: 'Không có thông tin khai hải quan để truy vấn.',
  ErrorSavingBusinessState: 'Lưu lỗi trạng thái kinh doanh',
  OrderInformationWasSuccessfullyUpdated: 'Cập nhật thông tin đặt hàng thành công.',
  NoExternalUpdateInformation: 'Không có thông tin cập nhật bên ngoài',
  ExternalInformationWasSuccessfullyUpdated: 'Cập nhật thông tin bên ngoài thành công',
  NodeStatusIsNotPreserved: 'Trạng thái nút không được lưu.',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: 'Mẫu thư liên kết nút không được duy trì.',
  DoNotLocateAnAssociatedPrintTemplateType: 'Không tìm thấy kiểu mẫu in liên quan.',
  TheEmailWasSentPleaseNoteTheQuery: 'Email đã được gửi, hãy chú ý đến yêu cầu!',
  PleaseSelectAFile: 'Vui lòng chọn File!',
  SureYouWantToDeleteFiles: 'Bạn chắc chắn muốn xóa tập tin?',
  EmailAddressCannotBeEmpty: 'Địa chỉ email không được để trống.',
  UploadSuccess: 'Tải lên thành công:',
  UploadFailed: 'Tải lên không thành công:',
  FileSizeExceedsMBYouCannotUpload: 'Dung lượng tập tin lớn hơn 20MB, không thể tải lên.',
  DoNotSelectedCategory: 'Chưa chọn loại tập tin.',
  PleaseSelectAJob: 'Vui lòng chọn danh sách công việc.',
  PleaseSelectTheSameTypeOfJob: 'Vui lòng chọn cùng loại danh sách công việc',
  NotStart: 'Chưa bắt đầu',
  PleaseSelectABusinessStatus: 'Vui lòng chọn tình trạng kinh doanh',
  PleaseSelectABusinessStatusDetails: 'Vui lòng chọn tình trạng kinh doanh',
  EditedSuccessfully: 'Sửa đổi thành công',
  PleaseContactTheSuperiorUnlocked: 'Bởi vì điều khiển tín hiệu vượt quá, vé đã bị khóa không thể in ra, xin liên hệ cấp trên mở khóa!',
  CanSuccessfullyPrint: 'Đã in thành công chưa?',
  ConfirmToPrint: 'Xác nhận in',
  CorrespondsToThePrintTemplateDoesNotFind: 'Không tìm thấy mẫu in tương ứng',
  FailedToGetTheTemplateType: 'Lấy mẫu loại thất bại!',
  NoSelectedTemplate: 'Chưa chọn mẫu.',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: 'Chuyển hàng loạt thành công, nếu bạn muốn đóng cửa sổ bật lên',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: 'Chuyển hàng loạt thành công, nếu bạn muốn đóng cửa sổ bật lên',
  NoFeesCanBeDeleted: 'Không có chi phí để loại bỏ.',
  NoSelectedCharge: 'Không chọn phí.',
  NoChargeCanBeSaved: 'Không có chi phí tiết kiệm.',
  ChargeNameCannotBeEmpty: 'Tên chi phí không được để trống.',
  ClearingTheObjectCannotBeNull: 'Đối tượng thanh toán không được để trống.',
  BusinessNumberIs0: 'Số lượng doanh nghiệp là 0.',
  CustomerIsNULL: 'Khách hàng trống',
  TheCarrierIsEmpty: 'Người vận chuyển trống rỗng.',
  AgentIsNULL: 'Đại lý đặt hàng/đại lý thay đổi là trống rỗng,',
  AgentIsNULL2: 'Đại lý ở nước ngoài/đại lý cảng đích là trống,',
  CustomsIsNull: 'Hành vi khai hải quan trống rỗng,',
  TerminalCompanyIsNull: 'Công ty bến tàu trống không,',
  TheObjectCannotBeUsedAsTheDefaultSettlement: 'Không thể làm đối tượng thanh toán mặc định.',
  AddSuccessfully: 'Thành công mới.',
  DisplaysTheCostOfUpdatingResults: 'Hiển thị kết quả cập nhật phí',
  TotalCost1: 'Tổng cộng',
  TotalCost2: 'Điều khoản chi phí,',
  Updated1: 'Cập nhật',
  Updated2: 'Thanh,',
  NotUpdated1: 'Và',
  NotUpdated2: 'Thanh chưa cập nhật.',
  NotMatchingTheCostOfTheProjectCanBeAdded: '<i class="el-icon-info" style="font-size: 16px;"></i><span style="font-size: 14px;margin-left: 5px;">Không có khoản phí phù hợp</span><b style="font-size: 16px;">Có thể thêm</b>',
  ChargeWasSuccessfullyUpdated: 'Chi phí cập nhật thành công.',
  NotMatchingTheCostOfTheProjectCanBeUpdated: 'Không có khoản phí phù hợp để cập nhật.',
  NoAddedCharge: 'Không có chi phí mới.',
  DefaultValuesAreSavedSuccessfully: 'Giá trị mặc định đã được lưu thành công.',
  ContSigned: '(Đã ký)',
  ContUnsigned: '(chưa ký)',
  InvalidCont: '(Hợp đồng hết hạn)',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: 'Hệ thống đã được cập nhật, vui lòng làm mới trang!',
  PleaseInputCosts: 'Vui lòng nhập chi phí.',
  SelectTheSurchargeClause: 'Vui lòng chọn điều khoản phụ phí.',
  HAWBCannotBeNull: 'Số đơn vị AMS không thể để trống!',
  ENSHblNbr2CannotBeNull: 'Số phụ ENS không thể để trống!',
  HAWBAfrCannotBeNull: 'Số HB/L không được để trống!',
  HAWBCannotBeRepeated: 'Số đơn vị AMS không thể lặp lại!',
  HAWBAfrCannotBeRepeated: 'Số HB/L không thể lặp lại!',
  InlandCannotBeNull: 'Điểm nội địa/nhà kho không thể trống rỗng!',
  rocordNumberCannotBeNull: 'Số hồ sơ hải quan Canada không được để trống!',
  AreYouSureYouWantToDelete1: 'Bạn chắc chắn muốn xóa',
  SureDeleteHbl: 'Không thể khôi phục sau khi xóa đơn đặt hàng, xác nhận xóa?',
  AreYouSureYouWantToDelete2: 'Phải không?',
  PleaseSelectTheAMSNO: 'Vui lòng chọn số AMS trước',
  PleaseSelectTheHBLNO: 'Vui lòng chọn số HB/L',
  TheMaximumCannotExceedLines: 'Tối đa không được vượt quá 5 dòng!',
  DisplayColumn: 'Cột hiển thị tùy chỉnh',
  Display: 'Hiển thị',
  Name: 'Tên cột',
  TradeCommissionedUnitCannotBeEmpty: 'Thương mại - Đơn vị ủy thác không được để trống',
  TradeSalesSupportCannotBeEmpty: 'Hỗ trợ thương mại - bán hàng không thể để trống',
  TradingCurrencyCannotBeEmpty: 'Giao dịch - Đơn hàng không thể để trống',
  TradingExchangeRateCannotBeEmpty: 'Giao dịch - Tỷ giá hối đoái không thể để trống',
  TradeServiceFeeDiscountRateCannotBeEmpty: 'Tỷ lệ chiết khấu phí thương mại - dịch vụ không được để trống',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: 'Thương mại - Số lượng đặt hàng hạt nhân không được lớn hơn số lượng đặt hàng',
  TradePaymentNOCannotBeEmpty: 'Thương mại - Số thanh toán không thể để trống',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: 'Thương mại - số thanh toán không thể lớn hơn 16 chữ số chiều dài',
  UnableToDeleteAllCharges: 'Không thể xóa toàn bộ chi phí.',
  PleaseCheckYourNetworkOrRefreshThePage: 'Thân, ngài hiện tại đang ở trong không gian dị thứ nguyên không có internet! Kiểm tra xem mạng có hoạt động không hoặc làm mới trang không.',
  TheFileIsSentSuccessfully: 'File đã được gửi thành công.',
  PleaseSelectAFileToDownloadOrSend: 'Vui lòng chọn tập tin cần tải xuống hoặc gửi.',
  PleaseSelectAFileSynchronization: 'Vui lòng chọn tập tin cần đồng bộ.',
  PleaseSelectAFileCancelSynchronization: 'Vui lòng chọn tập tin cần hủy đồng bộ.',
  FailedToModifyAFileType: 'Sửa đổi kiểu tập tin không thành công.',
  PleaseSelectAFileType: 'Vui lòng chọn loại tập tin.',
  MBLNOCannotBeDuplicated: 'MB/L NO2 không thể lặp lại!',
  PleaseSelectMBLNo: 'Vui lòng chọn số MBL.',
  TotalWeightOfLadingAreInconsistent: 'Đơn hàng tổng hợp không nhất trí!',
  TOORDERIsUnavailableToRelease: 'To order Không thể phóng điện',
  TheAssociatedPrimaryFormIsNotSelected: 'Danh sách liên kết Chưa chọn',
  PleaseSelectHBLNo: 'Vui lòng chọn số HBL trước!',
  PleaseEnterTheBillOfLadingSerialNumber: 'Vui lòng nhập số dòng chảy vận đơn trước!',
  PleaseUploadReleaseGuarantee: 'Không có bảo lãnh điện phóng có hiệu lực, vui lòng tải lên trước',
  TheRecipientAddressCannotBeEmpty: 'Địa chỉ người nhận không được để trống.',
  OperationIsNotReversible: 'Thao tác không thể đảo ngược.',
  Uncommitted: 'Chưa gửi',
  Approved: 'Kiểm toán',
  Submitted: 'Đã gửi',
  Rejected: 'Bị từ chối',
  PleaseSelect: 'Vui lòng chọn',
  Uploaded: 'Tải lên hoàn tất',
  Waiting: 'Chờ upload',
  Uploading: 'Đã tải lên',
  Other: 'Khác',
  First: 'Trang đầu',
  Pre: 'Trang trước',
  Page: 'Số',
  AllPage1: 'Tổng cộng',
  AllPage2: 'Trang',
  Next: 'Trang tiếp theo',
  Last: 'Trang cuối',
  ShowFromTo1: 'Hiển thị',
  ShowFromTo2: 'Đến',
  AllRecord1: 'Tổng cộng',
  Transactions: 'Bút',
  AllRecord2: 'Hồ sơ',
  Convert: 'Liên kết',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: 'Bạn không cấu hình kho nên không thể sử dụng chức năng này, nếu cần, vui lòng liên hệ với dịch vụ khách hàng trực tuyến.',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: 'Thân nhân, xin lưu nghiệp vụ trước, sau khi tiến hành thao tác phân phối hàng tự động.',
  FirstSaveTheBusinessAddSpecialGoods: 'Bạn ơi, hãy tiết kiệm công việc trước khi thêm hàng nguy hiểm.',
  GeneralTrade: 'Thương mại chung',
  ProcessingWithSuppliedMaterial: 'Xử lý nguyên liệu đến',
  ProcessingTrade: 'Cho ăn đúng miệng',
  SamplesOfAdvertisingProductsA: 'Mẫu quảng cáo A',
  Refuse: 'Từ chối',
  Agree: 'Đồng ý',
  GoOn: 'Tiếp tục đi.',
  SubmitAudit: 'Giới thiệu Supervisor Audit',
  DataValidation: 'Đang tiến hành kiểm tra dữ liệu',
  DataValidatedWithWarning1: 'Xác minh dữ liệu hoàn tất nhưng có cảnh báo',
  DataValidatedWithWarning2: 'Vui lòng bấm 【Tiếp tục đi.】 để hủy',
  DataValidatedWithWarning3: 'Nhấn vào [Bracket0]',
  DataValidatedSuccessfully1: 'Xác minh dữ liệu thành công, xác nhận',
  DataValidatedSuccessfully2: 'Vui lòng bấm 【Xác nhận】 để hủy',
  DataValidatedSuccessfully3: 'Nhấn vào [Bracket0]',
  DataValidatedFailure1: 'Xác minh dữ liệu không thành công, vui lòng xử lý các mục dữ liệu xác minh không vượt qua trước khi',
  DataValidatedFailure2: '',
  WoChat: 'Trò chuyện',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: 'Hệ thống đã được cập nhật, vui lòng đóng mô-đun để mở lại.',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: 'Hệ thống đã được cập nhật, vui lòng đăng nhập lại hoặc dọn dẹp bộ nhớ cache của trình duyệt.',
  AddAdjustment: 'Tăng điều chỉnh',
  AddCharge: 'Tăng phí',
  AddCostCharge: 'Phí phải thu mới',
  AddPayCharge: 'Chi phí phải trả mới',
  EditAdjustment: 'Sửa đổi điều chỉnh',
  EditCharge: 'Phí sửa đổi',
  EditCostCharge: 'Sửa đổi chi phí phải trả',
  EditPayCharge: 'Sửa đổi chi phí phải trả',
  DeleteAdjustment: 'Xoá điều chỉnh',
  DeleteCostCharge: 'Loại bỏ các khoản phí phải trả',
  DeletePayCharge: 'Xóa các khoản phải trả',
  DateOfAdjustmentCannotBeNull: 'Điều chỉnh ngày không được để trống.',
  CurrencyOfAdjustmentCannotBeNull: 'Tiền không thể để trống.',
  AmountCannotBeZero: 'Số lượng không thể bằng 0.',
  UnitPriceCannotBeZero: 'Đơn giá không thể bằng 0.',
  AmountCannotBeZero2: 'Số tiền không thể bằng 0.',
  ExchangeCannotBeZero2: 'Tỷ giá hối đoái không thể bằng 0.',
  RemarkTheLengthCannotExceed: 'Độ dài ghi chú không được vượt quá 50.',
  InvoiceNoCannotBeNull: 'Số thuế không được để trống.',
  InvoiceNoIsTooLong: 'Số thuế quá dài.',
  PleaseAddSpecialGoodsFirst: 'Vui lòng thêm hàng nguy hiểm trước',
  UNNoIsEmpty: 'Vui lòng điền số UN',
  LoadSpGoodsContainerError: 'Thông tin đóng gói hàng nguy hiểm bị lỗi',
  AssociatedSpGoodsError: 'Thông tin liên quan đến hàng hóa nguy hiểm',
  NoAssociatedInfo: 'Không có thông tin liên quan',
  InnerPackagingTypeIsRequired: 'Loại bao bì bên trong phải được điền',
  InnerPackagingQuantityIsRequired: 'Số lượng bao bì bên trong phải điền',
  SeaPollutionOnlyEnterYN: 'Giá trị trường ô nhiễm biển phải là Y hoặc N',
  SelectHsCode: 'Chọn số HS',
  SelectCargoChineseName: 'Chọn tên Trung Quốc',
  DispatchNotYet: 'Không giao hàng thành công. Không được thay đổi giao hàng.',
  AllDataMustBeOperating: 'Tất cả dữ liệu phải hoạt động tích cực',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: 'Vui lòng chọn loại hình kinh doanh phù hợp',
  TheNumberOfChargesLimited: 'Số lượng chi phí tối đa không được vượt quá',
  TheNumberOfSelectedDataLimited: 'Dữ liệu được đánh dấu không thể vượt quá',
  PleaseInputSearchCondition: 'Vui lòng nhập điều kiện yêu cầu',
  PlaceOfDeliveryCannotBeNull: 'Nơi giao hàng không thể để trống',
  ImportSuccessChargesCount: 'Nhập thành công {count} khoản phí',
  CheckChargeDetailBranch: 'Chi nhánh nơi dữ liệu đang hoạt động không thuộc chi nhánh hiện tại hoặc chi nhánh cấp cao hơn',
  ChangeSelectSales: 'Doanh số bán hàng có thay đổi không?',
  NoSelectedCargoDocInformation: 'Vui lòng kiểm tra hồ sơ vận đơn!',
  OverseaCostChargeEmpty: 'Phải thu phí là trống không!',
  OverseasBillsCanNotBePrinted: 'Hóa đơn ở nước ngoài không thể được in (hóa đơn trống, không được chọn, đã hết hạn, không có thẩm quyền)!',
  CheckHBLReleaseStateBeforePrint: 'Không phải đơn đặt hàng, không thể in!',
  NoSelectedWarehouseInInformation: 'Không chọn thông tin kho cần in!',
  NoWarehouseInInformation: 'Bạn đã chọn sai thông tin kho bãi!',
  ConfirmTheShutOut: 'Có chắc là muốn hủy bỏ việc kinh doanh vé không? Tất cả các khoản phí sẽ được xóa!',
  SaveSucceed: 'Tiết kiệm thành công!',
  SelectOneJob: 'Chỉ cho phép đánh dấu một phiếu nghiệp vụ để sao chép!',
  PleaseInputETD: 'Vui lòng chọn ngày khởi hành!',
  SelectJob: 'Vui lòng chọn doanh nghiệp!',
  DateToday: 'Hôm nay',
  PleaseSelectSoNo: 'Vui lòng chọn số đóng',
  ChargeOffsetState: 'Chi phí đã đỏ hoặc bị đỏ.',
  isDeleteAllEDIContainer: 'Xóa tất cả thông tin đóng gói',
  ServiceCodeCannotBeNull: 'Mã dịch vụ không được để trống',
  Choose: 'Chọn',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: 'Hóa đơn này đã được gửi để xem xét tài chính và không thể bị xóa bắt buộc.',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: 'Danh sách này đã được bán hạt nhân và không thể bị xóa bắt buộc.',
  ThisFormIsLockedAndCannotBeForceDel: 'Danh sách này đã bị khóa và không thể bị xóa bắt buộc.',
  ConfirmTheForceDelOfTheBill: 'Quyết định buộc xóa hóa đơn này?',
  ForceDelSuccessfully: 'Buộc gỡ bỏ thành công',
  IsNotOperationStatusCannotBeShutOut: 'Chỉ có thể đóng cửa số lượng lớn các doanh nghiệp ở trạng thái "hoạt động tích cực".',
  IsNotOperationStatusCannotBeCancellation: 'Chỉ có thể hủy bỏ hàng loạt trạng thái "hoạt động tích cực".',
  ManifestLink: 'Bản kê khai liên kết dưới đây',
  ApplicationAmountCheck: 'Số tiền yêu cầu thanh toán không khớp với tổng số tiền trong danh sách phí, vui lòng kiểm tra!',
  TipsOnSplittingExpenses: 'Kim ngạch chi phí chia tách không thể lớn hơn kim ngạch chi phí ban đầu, xin sửa đổi kim ngạch chi phí chia tách!',
  DcCopyCheck: 'Nghiệp vụ này có nhân viên chứng từ không có thông tin bộ phận hoặc công ty, xin vui lòng chọn lại chứng từ!',
  CsrCopyCheck: 'Nghiệp vụ này có nhân viên phục vụ khách hàng không có bộ phận hoặc thông tin công ty, xin vui lòng chọn lại dịch vụ phục vụ khách hàng!',
  SureDeleteThese: 'Hãy chắc chắn để loại bỏ điều này',
  OrdersOfBusiness: 'Nghiệp vụ vé sao?',
  SureCancellationAndDeleteCharge: 'Có chắc là muốn hủy bỏ công việc không? Tất cả các chi phí sẽ được loại bỏ!',
  SureShutOutAndDeleteCharge: 'Có chắc là anh muốn rút lui không? Tất cả các chi phí sẽ được loại bỏ!',
  CheckingConsignation: 'Doanh nghiệp không thể được ủy thác, vui lòng thử lại sau khi kiểm tra!',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: 'Phiếu nhỏ này đã được ghép lại, không thể xóa bỏ.',
  SaveFailedMessage: 'Lưu không thành công, vui lòng thử lại sau khi làm mới!',
  SettlementAgentCannotBeNull: 'Đại lý thanh toán không thể để trống!',
  SettlementAgentErrorPleaseReSelect: 'Lỗi đại lý thanh toán, vui lòng chọn lại!',
  NowContainer: 'Hộp hiện tại',
  NowContainerCanNotDelete: 'Hộp hiện tại đã được sử dụng và không thể bị xóa!',
  NotDelete: 'Không thể xóa!',
  PleaseSelectBoxType: 'Vui lòng chọn loại hộp!',
  PleaseEnterUnitPrice: 'Vui lòng nhập đơn giá!',
  PleaseSelectCurrency: 'Vui lòng chọn đồng tiền!',
  PleaseEnterTheStartDate: 'Vui lòng nhập ngày thuê!',
  PleaseEnterThebuyDate: 'Vui lòng nhập ngày mua hộp!',
  PleaseEnterEndDate: 'Vui lòng nhập ngày kết thúc!',
  SuccessfulBoxAdjustment: 'Điều chỉnh hộp thành công! Số lượng đã xử lý',
  NoBoxesProcessedSuccessfully: 'Không xử lý hộp thành công, vui lòng kiểm tra hộp thực tế!',
  OnlyBuyCaseOrderBoxCanBeSold: 'Chỉ có thể bán hộp đặt hàng, xin kiểm tra!',
  ChoiceCaseSell: 'Vui lòng chọn hộp khác để bán!',
  PleaseContainerData: 'Vui lòng nhập thông tin hộp!',
  UnifiedCurrency: 'Đơn đặt hàng chỉ hỗ trợ đơn vị tiền tệ, xin thống nhất bán đơn vị tiền tệ!',
  PleaseCheckTheBoxToBeSold: 'Vui lòng chọn hộp để bán!',
  EditedFailMessage: 'Sửa đổi không thành công, vui lòng thử lại sau khi làm mới!',
  DataValidatedWithPartialPass1: 'Xác thực dữ liệu hoàn tất nhưng có một phần cảnh báo và thất bại để tiếp tục',
  DataValidatedWithPartialPass2: 'Vui lòng bấm 【Tiếp tục đi.】 để hủy',
  DataValidatedWithPartialPass3: 'Xin vui lòng nhấn 【Hủy bỏ】 Lưu ý: Xác minh không thành công, vui lòng xử lý các mục dữ liệu xác minh không thông qua',
  AddChangeCharge: 'Chi phí thay đổi mới',
  ThereAreNoPayableBillsToPrint: 'Không có danh sách thanh toán để in.',
  ReleaseInformationNotSelected: 'Thông tin chưa chọn',
  AreYouSureYouWantTo: 'Bạn có chắc là bạn muốn {0}?',
  NoRecordsAvailable: 'Không có ghi chép nào.',
  NoDataToAudit: 'Không có dữ liệu để kiểm tra.',
  NoSplittingRecordSelected: 'Không có bản ghi nào được chọn.',
  NoDataToAudit2: 'Không có dữ liệu nào có thể',
  EditChangeCharge: 'Chi phí sửa đổi',
  AddSpecialCharge: 'Phí đặc biệt mới',
  EditSpecialCharge: 'Sửa đổi phí đặc biệt',
  AddSpecialUpdate: 'Điều chỉnh chi phí đặc biệt',
  Pstsftba: 'Vui lòng chọn chi phí đặc biệt cần điều chỉnh!',
  Nsecbe: 'Không thể chỉnh sửa chi phí không đặc biệt!',
  UpdateWarehouseRecord: 'Các thay đổi trong kho có tiếp tục được bảo quản không?',
  CheckCostAndBusinessMismatching: 'Các khoản phí được đánh dấu không phù hợp với doanh nghiệp',
  TicketEntrustedCannotRepetitionDelegate: 'Vé này đã được ủy thác, xin đừng lặp lại ủy thác!',
  NotFindCurrencyRatePleaseMaintain: 'Không tìm thấy tỷ giá hối đoái cho {0} tiền tệ, xin vui lòng giữ tỷ giá hối đoái liên quan kịp thời và lưu lại!',
  BillPaymentDeleteTips: 'Chỉ có thể xóa đơn yêu cầu thanh toán không phải là trạng thái đã được phê duyệt tài chính và chưa được tiếp thị hạt nhân',
  SettlementAgentNotNull: 'Đại lý thanh toán không thể để trống!',
  PleaseSelectSameSettlementAgent: 'Vui lòng chọn hóa đơn của cùng một đại lý thanh toán!',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: 'Đại lý cảng đích vé nhỏ mới được chọn, cảng bốc hàng, cảng đích, đại lý đặt hàng, hãng hàng không, chuyến bay, ETD, Tính chất đặt phòng, điều khoản vận chuyển đơn hàng chính n không phù hợp với vé chính, hệ thống sẽ sửa đổi vé nhỏ, có tiếp tục không?',
  AMS_ReturnMessage: 'Thông tin về hộp đựng AMS không phù hợp với thực tế, vui lòng điều chỉnh! \n',
  AMS_ReturnMessageCanSave: 'Thông tin về thân tóc của vali AMS không khớp với thực tế, bạn có tiếp tục lưu không? \n',
  AMS_Quantity: '【Số kiện AMS {0} {1} Số kiện thực tế {2}】\n',
  AMS_Weight: '【Tổng trọng lượng AMS {0} {1} Tổng trọng lượng thực tế {2}】\n',
  AMS_Cubage: '【Thể tích AMS {0} {1} Thể tích thực tế {2}】\n',
  AMS_ContainerNo: 'Số hộp 【{0}】:n',
  CheckPortsByConsignation: 'Bạn ủy thác 【{0}】 không có bảo trì 【{1}】 cổng, xin vui lòng kiểm tra với đối phương sau đó tiến hành ủy thác!',
  CheckPackingByConsignation: 'Bạn ủy thác 【{0}】 không có bảo trì 【{1}】 đóng gói, xin vui lòng kiểm tra với đối phương sau đó tiến hành ủy thác!',
  CheckCompanyByConsignation: 'Bạn ủy thác 【{0}】 không có mã SCAC bảo trì 【{0}】, v.v., xin vui lòng kiểm tra lại với đối phương trước khi ủy thác!',
  CheckCarrier: 'Vui lòng duy trì mã SCAC của 【{0}】 trước khi ủy quyền!',
  SettleAccountMustBeSame: 'Đối tượng thanh toán phải giống nhau',
  ReceivableCannotMorethanPay: 'Chi phí phải thu không được lớn hơn chi phí phải trả',
  PleaseSelectJobs: 'Vui lòng chọn danh sách doanh nghiệp',
  SapCommitCheck: 'SAP Một D/P đã hoàn thành, không lặp lại D/P',
  SapCancelCommitCheck: 'Phí không thể rút lại trạng thái SAP, vui lòng xác nhận trạng thái SAP của phí',
  escnm: 'Bộ phận thanh toán chi phí không được duy trì',
  SapSynchronizationSuccess: 'Chi phí đồng bộ hóa SAP thành công',
  SapSynchronizationFault: 'Phí đồng bộ hóa SAP không thành công',
  SapStatusCanNotAudit: 'Phí không thể kiểm tra trạng thái SAP, vui lòng xác nhận trạng thái SAP của phí',
  ChangeOrderSubmissionFailed: 'Nộp đơn sửa đổi thất bại, không kiểm tra được chi phí cần sửa đổi!',
  SureYouWantToDeleteFilesTwo: 'Bạn có chắc chắn muốn xóa {0} tập tin này hàng loạt?',
  JumpFailed: 'Nhảy không thành công',
  SelectCopyContent: 'Chọn nội dung sao chép',
  CopyContent: 'Sao chép nội dung',
  SelectImportContent: 'Chọn Import',
  ImportContent: 'Nhập nội dung',
  DifferenceOverwritesTheOriginalValue: 'Trường khác biệt ghi đè giá trị gốc',
  DifferenceRetainsTheOriginalValue: 'Trường khác biệt giữ nguyên giá trị gốc',
  RememberToChoose: 'Lời bài hát: Remember My Choice',
  TheImportedServiceNumberDoesNotExistProcedure: 'Nhập không thành công, số doanh nghiệp đã nhập không tồn tại, hãy thử lại!',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: 'Nhập khẩu không thể giống với số doanh nghiệp được nhập khẩu',
  CopyNumber: 'Số lượng bản sao này',
  QuickSearchBusinessNo: 'Truy cập nhanh: Số doanh nghiệp',
  FinancialDateOfASingleExpense: 'Bạn có chắc chắn muốn thay đổi ngày tài chính cho một khoản phí duy nhất?',
  ExpenseFinancialDateModifiedSuccessfully: 'Chi phí Ngày tài chính Sửa đổi thành công',
  ModifyTheFinancialDate: 'Bạn muốn thay đổi ngày tài chính?',
  FinancialDateModifiedSuccessfully: 'Sửa đổi ngày tài chính thành công',
  ApprovalDateIsEarlierThanBusinessDate: 'Ngày đánh giá nhỏ hơn ngày kinh doanh, bạn có tiếp tục không?',
  AreYouSureToReviewTheseLists: 'Bạn có chắc chắn về việc xem xét các danh sách này?',
  ThisBusinessIsNotApproved: 'Doanh nghiệp này không phải là [{0}] trạng thái, kiểm toán không được phép, vui lòng kiểm tra!',
  ThisBusinessIsNotApproved2: 'Doanh nghiệp không phải là [{0}] trạng thái và không được phép rút tiền, vui lòng kiểm tra!',
  TheDocumentChangeSubmission: 'Có chắc là muốn rút lại đơn xin thay đổi không?',
  AllowOrderChange: 'Có chắc là muốn cho phép thay đổi đơn hàng không?',
  AllowToChangeTheOrderSuccessfully: 'Cho phép thay đổi thành công',
  NoExpenseSelectedOrNotInApprovalStatus: 'Không chọn phí hoặc trạng thái không kiểm tra',
  ExpenseStatusUpdatedSuccessfully: 'Cập nhật trạng thái chi phí thành công',
  BusinessHasGeneratedVouchers: 'Doanh nghiệp đã tạo ra chứng từ,',
  UnableCancelAudit: 'Không thể hủy bỏ kiểm duyệt.',
  BusinessNumberWithGeneratedVouchers: 'Số doanh nghiệp với chứng từ đã tạo:',
  AreYouSureYouWantToCancelTheApproval: 'Bạn có chắc chắn muốn hủy một cuộc kiểm toán?',
  LCLTicketsCannotBeReviewedSeparately: 'Phiếu nhỏ ghép lại không thể xét duyệt riêng, xin xét duyệt phiếu chính.',
  ItIsLocked: 'Đã khóa, không in được, xin hãy liên lạc với cấp trên để mở khóa!',
  PleaseSelectTheBusiness: 'Vui lòng chọn doanh nghiệp cần sửa đổi ngày kinh doanh',
  BusinessDateModifiedSuccessfully: 'Thay đổi ngày kinh doanh thành công',
  BatchApprovalFailed: 'Kiểm toán hàng loạt thất bại',
  PleaseSelectTheBusinessToPrint: 'Vui lòng chọn doanh nghiệp cần in',
  NoInTheSelectedData: 'Chọn dữ liệu trong số các doanh nghiệp không có trạng thái 【{0}】, không được phép kiểm toán, vui lòng kiểm tra!',
  TheApprovalDateIsEarlierThanTheBusinessDate: 'Ngày đánh giá nhỏ hơn ngày kinh doanh, bạn có tiếp tục không?',
  FailedToGetDetails: 'Lỗi lấy chi tiết',
  PleaseEnterTheBoxSealNumber: 'Sau khi nhập số niêm phong hộp, hãy in bảng phân tích lợi nhuận.',
  AfterPrintingTheProfitAnalysisStatement: 'Sau khi in bảng phân tích lợi nhuận, đơn hàng này sẽ được gửi để xem xét tài chính và không thể thay đổi được nữa. Tiếp tục không?',
  PleaseEnterTheApprovalDate: 'Vui lòng nhập ngày đánh giá',
  PleaseSelectARecordToView: 'Vui lòng chọn một bản ghi để xem',
  ContractExpireCannotCreated: 'Hợp đồng của đơn vị ủy thác này hết hạn và không thể tạo doanh nghiệp nữa',
  CheckBusinessStatus: 'Thao tác không thành, hãy kiểm tra tra trạng thái tương ứng nghiệp vụ có bình thường hay không.',
  CheckCustomsSaved: 'Xin lưu thông tin tờ khai hải quan trước, sau đó tải lên tài liệu tờ khai hải quan!',
  SelectCustomsBroker: 'Vui lòng chọn môi giới hải quan.',
  SelectCustomsBrokerPlatFormProvider: 'Bạn không có trong đối tác, cấu hình "nhà cung cấp nền tảng" cho nhà môi giới hải quan hiện được chọn và không thể gửi.',
  SelectCustomsSonoLobFiles: 'số hóa đơn", đại lý hải quan, thông tin hải quan, loại hình kinh doanh không được để trống, xin vui lòng kiểm tra dữ liệu',
  VesselAndvVoyageFlightisEmpty: 'Tên tàu trống, xin vui lòng gửi',
  customsInfoIsAlredySend: 'Tờ khai hải quan này đã được gửi, tạm thời hỗ trợ gửi một lần, nếu cần sửa đổi xin vui lòng liên hệ trực tuyến với nhà môi giới hải quan tương ứng',
  DocumentEditedTips: 'Bạn không phải là chứng từ của vé và không thể chỉnh sửa.',
  CustomerTipMessage: '【{0}】 Không phải đơn vị ủy thác, vui lòng chọn lại!',
  PortOfLoadingPortCannotBeNull: 'Cảng bốc hàng không thể để trống',
  PromissoryNoteIsAFormalBusiness: 'Vé đã là nghiệp vụ chính thức!',
  CannotBeConvertedToFormalBusinessInBatch: 'Thông tin bao gồm nguồn nghiệp vụ là "nghiệp vụ của mình trong hộ thuê", không thể xử lý với số lượng lớn chuyển sang nghiệp vụ chính thức.',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: 'Có nên chuyển hóa đơn chính thức cùng một lúc không?',
  transferSmallTicketToFormalJobAtTheSameTime: 'Đồng thời chuyển hóa đơn chính thức',
  onlyTheMasterTicketIsTransferredToFormalJob: 'Chỉ có vé chính thức chuyển sang nghiệp vụ chính thức.',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: 'Xin vui lòng chuyển phiếu chính thức sang nghiệp vụ chính thức trước!',
  BusinessCannotBeOperatedTogether: 'Nghiệp vụ thông thường và nghiệp vụ ủy thác không thể cùng thao tác, xin chọn lại!',
  PleaseEnterTheWarehouseNumber: 'Truy xuất nhanh: Số kho vào',
  BookingSeal: 'Đăng ký',
  CheckSplitCharges: 'Chi phí đã được chia, vui lòng xóa chi phí chia trước',
  mutualChargeSynchronizationSuccess: 'Chi phí ủy thác chéo đồng bộ thành công!',
  mutualChargeSynchronizationFault: 'Đồng bộ hóa chi phí ủy quyền chéo thất bại!',
  confirmQuit: 'Có chắc là rút lui không?',
  SelectMBL: 'Số vận đơn (ký hiệu đặt hàng - MB/L NO) không được để trống',
  SelectMBLSI: 'Số đơn chính (hoạt động nhập khẩu - số đơn chính) không được để trống',
  SelectMBLAE: 'Đơn vị chính (Basic - Master) không được để trống',
  SelectMBLAI: 'Số đơn chính (vận hành bằng đường hàng không - số đơn chính) không được để trống',
  SelectLob: 'Vui lòng chọn loại hình kinh doanh.',
  SelectPreCustomsDate: 'Vui lòng chọn ngày dự báo.',
  SelectHarborDistrictSe: 'Khu vực cảng không được để trống',
  SelectHarborDistrictSi: 'Khu vực cảng (hoạt động nhập khẩu - khu vực cảng) không được để trống',
  DestinationPlaceNotNull: 'Nơi giao hàng (hoạt động nhập khẩu - nơi giao hàng) không được để trống!',
  AirportPortNotNull: 'Cổng sân bay không được để trống',
  ExpectedDateOfArrivalNotNull: 'Ngày dự kiến đến cảng (hoạt động nhập khẩu - ngày đến cảng) không được để trống!',
  SelectCustomsFiles: 'Vui lòng chọn thông tin hải quan.',
  CustomsHasBeanSend: 'Tờ khai hải quan này đã được gửi, tạm thời hỗ trợ gửi một lần, nếu cần sửa đổi xin vui lòng liên hệ với nhà môi giới hải quan tương ứng',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: 'Một tập tin không thể vượt quá 20M, xin vui lòng gửi thư ngoại tuyến đến xh08@thecustoms.com.cn Hộp thư',
  PleaseUploadFileSeaExport: 'Xin vui lòng tải lên các tài liệu như giấy ủy thác khai hải quan, thông tin khoang phụ, giấy tờ khai hải quan xuất khẩu và các yếu tố khai báo hàng hóa, hóa đơn, hóa đơn......',
  PleaseUploadFileSeaImport: 'Vui lòng tải lên các tài liệu như ủy quyền khai hải quan, vận đơn đường biển trọn gói, thông tin nhận hàng hoặc bản sao, hóa đơn, danh sách hộp, hợp đồng, chứng nhận xuất xứ, các yếu tố kê khai hàng hóa.',
  PleaseUploadFileAirExport: 'Xin vui lòng tải lên các tài liệu như giấy ủy thác khai hải quan, giấy vận chuyển, giấy tờ khai hải quan xuất khẩu......',
  PleaseUploadFileAirImport: 'Vui lòng tải lên các tài liệu như ủy quyền khai hải quan, thông báo đến, vận đơn vận chuyển hàng không, hóa đơn, danh sách hộp, hợp đồng, chứng nhận xuất xứ, các yếu tố kê khai hàng hóa, v.v.',
  SuccessfulCustoms: 'Khai hải quan thành công!',
  FaildCustoms: 'Yêu cầu khai hải quan không thành công, vui lòng liên hệ với quản trị viên!',
  AsyncReceivableChargesToImportJob: 'Tất cả các khoản phí phải thu sẽ được đồng bộ hóa vào hoạt động nhập khẩu, việc tiếp tục có được xác nhận không?',
  AsyncPayableChargesToImportJob: 'Tất cả các chi phí phải trả được đồng bộ hóa vào hoạt động nhập khẩu, việc tiếp tục có được xác nhận không?',
  escnm2: 'Bộ phận thanh toán chi phí không thể để trống.',
  SelectMoreTwoRow: 'Vui lòng chọn ít nhất hai phần dữ liệu để kết hợp!',
  OnlySplitMasterJob: 'Chỉ có thể chia ra phiếu chính!',
  SplitJobTip: 'Vui lòng đánh dấu vào phiếu chính của Buyer Console FCL với trạng thái kinh doanh là phiếu chính đang hoạt động để chia nhỏ!',
  CombinationJobSelectMasterTip: 'Bạn có chắc chắn về việc kết hợp các doanh nghiệp sau đây, vui lòng chọn một nhân viên kinh doanh làm phiếu chính không?',
  CombinationJobForFcl: 'Các loại FCL và Buyer Console',
  CombinationJobForJobState: 'Trạng thái hoạt động tích cực',
  CombinationJobForCustomer: 'Đơn vị ủy thác phù hợp',
  CombinationJobForVessel: 'Tên tàu phù hợp',
  CombinationJobForVesselVoyage: 'Chuyến bay phù hợp',
  CombinationJobForMaster: 'Vui lòng chọn vé chính!',
  CombinationJobTip: 'Vui lòng chọn {0} doanh nghiệp để hoạt động!',
  ValidateCombinationJobTip: 'Doanh nghiệp có số vận đơn {0} đã được sử dụng, vui lòng nhấp vào nút hủy để thực hiện lại hoạt động kết hợp!',
  OnlyJoinForCombinationJob: 'Chỉ cho phép các doanh nghiệp tham gia vào các loại cắt ghép hoàn chỉnh cho FCL và Buyer Console!',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: 'Hóa đơn ngẩng đầu không nhất trí, có tiếp tục hay không?',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: 'Tên tàu, chuyến bay, người vận chuyển, đại lý đặt khoang, đại lý cảng đích, ETD、ETA、 Thông tin kho hàng, số hiệu công ty tàu không phù hợp với vé chính. Hệ thống sẽ thay đổi hóa đơn nhỏ. Tiếp tục không?',
  HblNoMoreThanTwelve: 'Số điểm không thể vượt quá 12!',
  WriteOffPushSuccess: 'Kỷ lục tiêu thụ hạt nhân đã được đẩy thành công!',
  WriteOffPushError: 'Việc đẩy kỷ lục tiêu thụ hạt nhân thất bại!',
  CancelConfirmBill: 'Đồng bộ hóa phí hủy để xác nhận trạng thái?',
  AreYouSureYouWantToDeleteTheSelectedFee: 'Xác nhận loại bỏ phí đã chọn?',
  JobOfClosingAccountTip: 'Ngày kinh doanh không thể được lưu, hãy điều chỉnh nó!',
  ThePacketHasBeenSentAndWhetherToImportItAgain: 'Đã gửi tin nhắn, bạn đã nhập lại chưa?',
  PleaseCheckAtLeastOnePieceOfData: 'Vui lòng chọn ít nhất một dữ liệu',
  NoHasViewRole: 'Không có quyền xem, hãy liên hệ với quản trị viên để cấu hình!',
  NoHasViewBillingRole: 'Không có quyền xem hóa đơn, vui lòng liên hệ với quản trị viên để cấu hình!',
  NoHasViewBillingGroupRole: 'Không có quyền xem sao kê, vui lòng liên hệ với quản trị viên để cấu hình!',
  checkSpecialChargeTips: 'Không thể tạo chứng từ có chi phí đặc biệt trong hồ sơ bán hàng, xin vui lòng chọn lại!',
  CheckCustomJobTypeTips: 'Vui lòng chọn loại hình kinh doanh tùy chỉnh trước khi lưu!',
  AMSCodeCannotBeNull: 'Cấu hình cơ bản AMSCompanyCode không thể để trống!',
  MblNoIsOverLength: 'Trường 【MB/L NO】 có hơn 16 bit.',
  AmsNoIsOverLength: 'Trường 【AMS NO】 có hơn 12 bit.',
  IsOverLengthTip: '{0} ký tự siêu dài, không vượt quá {1} ký tự cho mỗi dòng dữ liệu.',
  UnitTypeNotNull: 'Unit Type không thể để trống, vui lòng nhập',
  Shipper: 'Gửi hàng',
  Consignee: 'Người nhận hàng',
  Notify: 'Thông báo',
  SecondNotify: 'Thông báo thứ hai',
  SpecialCharacter: '{0} Trường chứa các ký tự bất hợp pháp và không thể lưu!',
  TipsOnAutoSplittingCharge: 'Xin vui lòng nhập giá bao gồm thuế của chi phí chia tách!',
  DeleteSmallTicketTips: 'Bạn không có quyền xóa vé số!',
  SyncToSmallTicketSuccessTips: '{0} Trạng thái nút đã được đồng bộ hóa với hóa đơn!',
  OperationTypeInUsed: '{0}{1} Đã có {2} Điều khoản vận chuyển được hiển thị theo mặc định, vui lòng chọn lại!',
  StartUpdatingTheBasicData: 'Bắt đầu cập nhật dữ liệu cơ bản',
  BasicDataUpdateSuccessfully: 'Cập nhật dữ liệu cơ bản thành công',
  BatchSubmitCheck: 'Chỉ có thể đệ trình hàng loạt danh sách hoạt động tích cực hoặc đệ trình trước!',
  isExistHBLANDMBLTips: 'Số phụ dưới một số chính không được phép lặp lại, vui lòng nhập lại số phụ!',
  operateTypeUpdateTips: 'Thay đổi chế độ hoạt động, có cập nhật thông tin MAWB không',
  SettlingAgentInconsistent: 'Đại lý thanh toán không nhất quán, có tiếp tục không?',
  SettlingAgentInvoiceTitleInconsistent: 'Đại lý thanh toán và hóa đơn ngẩng đầu đều không nhất trí, có tiếp tục hay không?',
  ChargeEmpty: 'Chi phí trống!',
  NoChargeForTheSettlementOfPrint: 'Không có đối tượng thanh toán chi phí phù hợp với điều kiện in ấn.',
  PleaseEnterTheCreationDate: 'Vui lòng nhập ngày tạo.',
  SelectDate: 'Chọn ngày',
  DefaultCurrency: 'Đồng tiền mặc định',
  EDISUBMISSIONCenter: 'Trung tâm báo cáo EDI',
  EDICenter: 'Trung tâm EDI',
  MessagePreview: 'Xem thử báo cáo',
  MessageDesign: 'Thiết kế báo chí',
  ReceiverCodeCannotBeEmpty: 'Mã người nhận không được để trống',
  SelectEDIType: 'Chọn loại EDI',
  NotConfigured: 'Chưa cấu hình',
  SelectSendingChannel: 'Chọn kênh gửi',
  SelectFileNature: 'Chọn tính chất tập tin',
  SelectFileTemplate: 'Chọn mẫu tập tin',
  SelectedBusiness: 'Doanh nghiệp đã chọn:',
  BackToEDICenter: 'Trở lại EDI Center',
  Design: 'Thiết kế',
  SendAll: 'Gửi tất cả',
  Tips: 'Gợi ý:',
  UsedInTemplateDesign: 'Sử dụng trong thiết kế mẫu',
  Check: 'Kiểm tra',
  SentSuccessfully: 'Gửi thành công!!',
  TemplateSavedSuccessfully: 'Lưu mẫu thành công',
  OtherDocuments: 'Tài liệu khác',
  ClickUpload: 'Click vào Upload',
  UnsupportedFileType: 'Kiểu tập tin không được hỗ trợ',
  TheSizeExceedsTheLimit: 'Kích thước tập tin vượt quá giới hạn',
  UploadFailed2: 'Upload thất bại',
  PleaseSelectABusinessNumber: 'Vui lòng chọn số doanh nghiệp',
  TheExceeds20MBAndUploaded: '1 tệp có dung lượng lớn hơn 20MB và không thể tải lên.',
  UploadPleaseContactTheAdministrator: 'Tải lên không thành công, vui lòng liên hệ với quản trị viên.',
  FailedPleaseRefreshAndAgain: 'Lấy dữ liệu không thành công, vui lòng thử lại sau khi làm mới',
  ExternalImportedDataNonEditable: 'Nhập dữ liệu bên ngoài, không thể chỉnh sửa',
  ExternalDataCannotBeDeleted: 'Nhập dữ liệu bên ngoài, không thể xóa.',
  RequestSucceededExporting: 'Yêu cầu thành công, xuất khẩu!',
  Main: 'Lớn',
  PleaseEnterTheWarehousingNumber: 'Vui lòng nhập số nhà kho!',
  PleaseEnterTheWarehouseName: 'Vui lòng nhập tên kho!',
  PleaseEnterTheWarehouseInDate: 'Vui lòng chọn thời gian nhập kho!',
  PleaseMaintainWeighDetail: 'Xin vui lòng duy trì trọng lượng (thực tế) hàng hóa chi tiết trước!',
  PleaseEnterComments: 'Kết quả hạt nhân không thông qua, xin điền ý kiến xử lý!',
  PleaseSelectTheClosingWeight: 'Vui lòng chọn trọng lượng đóng cửa!',
  SureToSaveLabeling: 'Chưa cân, vui lòng xác nhận bạn có lưu thông tin ghi nhãn không?',
  PleaseLengthWidthPieces: 'Vui lòng nhập kích thước theo định dạng chính xác: L * W * H * Số lượng mảnh!',
  PleaseTheNumberOfPieces: 'Vui lòng nhập số lượng!',
  WarehouseNumberAlreadyExistsContinue: 'Số nhà kho đã có, có tiếp tục không?',
  SavedSuccessfully: 'Tiết kiệm thành công!',
  ChecklistSuccessfully: 'Cập nhật trạng thái hạt nhân thành công!',
  NoSynchronizationContent: 'Không có nội dung đồng bộ.',
  ThereSynchronizationSpecialGoodsSynchronize: 'Trong thông tin đóng gói có hộp liên quan đến hàng hóa đặc biệt, sau khi đồng bộ hóa hàng hóa đặc biệt cần liên kết lại, có xác nhận đồng bộ hóa không?',
  SynchronizationSucceeded: 'Đồng bộ hóa thành công',
  SynchronizationFail: 'Lỗi đồng bộ',
  ThisJobIsNotWorkingCanNotBeEdited2: 'Chỉ định doanh nghiệp không hoạt động dương, không thể thực hiện đồng bộ.',
  ASameBoxTypeExists: 'Đã có một bản ghi của cùng một loại hộp!',
  IfToRefreshTheContainers: 'Số lượng hộp xảy ra thay đổi, có đổi mới chi phí vốn có theo số hộp làm đơn vị không?',
  BusinessCannotBeEmpty: 'Nghiệp vụ không thể để trống!',
  ViewChargebackFile: 'Xem hồ sơ hoàn tiền',
  SelectDepartment: 'Chọn bộ phận',
  PleaseSelectADepartment: 'Vui lòng chọn bộ phận!',
  ReceiptSucceeded: 'Chấp nhận thành công',
  ReceiptError: 'Lỗi nhận lại',
  SubmittedForDeletion: 'Đã gửi sửa đổi',
  ModificationFailed: 'Sửa đổi thất bại',
  EDIStatusChangeRecord: 'Bản ghi thay đổi trạng thái EDI',
  FeedbackNode: 'Nút phản hồi',
  YouTheLinkAddressDirectly: 'Sao chép trực tiếp địa chỉ liên kết',
  HistoricalAnomaly: 'Lịch sử bất thường',
  TimeOfOccurrence: 'Thời gian xảy ra',
  VerificationOfEstimatedProfitMargin: 'Xác minh biên lợi nhuận ước tính',
  EstimatedIncome: 'Thu nhập ước tính',
  EquivalentToRMB: 'Tương đương CNY',
  EstimatedCost: 'Chi phí ước tính',
  EstimatedProfit: 'Lợi nhuận ước tính:',
  EstimatedProfitMargin: 'Biên lợi nhuận ước tính:',
  EstimatedRemarks: 'Ghi chú dự đoán:',
  EstimatedMustBeFilledIn: 'Ghi chú dự kiến phải được điền.',
  Sunday: 'Chủ Nhật',
  Monday: 'Thứ hai',
  Tuesday: 'Thứ ba',
  Wednesday: 'Thứ Tư',
  Thursday: 'Thứ năm',
  Friday: 'Thứ sáu',
  Saturday: 'Thứ bảy',
  SelectFileType: 'Chọn kiểu tập tin',
  FileInformation: 'Thông tin tài liệu',
  Thumbnail: 'Hình thu nhỏ',
  DownloadPhotos: 'Tải ảnh',
  UploadComplete: 'Tải lên xong!',
  UploadFailedSigh: 'Tải lên thất bại!',
  HelloNNPleaseCheck: 'Xin chào, xin vui lòng kiểm tra',
  WarehousingNo: 'Số nhà kho -',
  WarehousingNoColon: 'Số nhà kho là:',
  PhotosNthankYouN: 'Hình ảnh cảm ơn',
  SendingSucceeded: 'Gửi thành công!',
  SendingFailed: 'Gửi thất bại!',
  PleaseTheFileToDownload: 'Vui lòng chọn tập tin cần tải xuống.',
  WaybillNo: 'Số vận đơn là:',
  ConfirmSending: 'Xác định gửi',
  ReturnToModify: 'Quay lại sửa đổi',
  ChannelName: 'Tên kênh',
  PleaseSelectASendingChannel: 'Vui lòng chọn kênh gửi!',
  FailedToGetTemplate: 'Lỗi lấy mẫu',
  TheDocumentOfTheContinue: 'Tên tàu mới được chọn, công ty tàu, đơn hàng chính, đại lý thay đổi đơn hàng, ngày khởi hành, ngày dự kiến đến cảng, ngày thực tế đến cảng, kho, phương thức đặt hàng chính và điều khoản vận chuyển đơn hàng chính không phù hợp với vé chính; Hoặc hóa đơn hải quan nhỏ là trống không. Hệ thống sẽ thay đổi phiếu nhỏ. Tiếp tục không?',
  PleaseSelectACodingRule: 'Vui lòng chọn quy tắc mã hóa.',
  ApplicationForRelease: 'Yêu cầu đặt phòng',
  ApplyForShipperCode: 'Ứng dụng Shipper Code',
  NoDataSelected: 'Dữ liệu không được chọn!',
  InvalidFee: 'Phí không hợp lệ!',
  ReceivingMethod: 'Cách nhận:',
  CellPhoneNumber: 'Số điện thoại:',
  NoteDoesNotAffectPartner: 'Lưu ý: Thông tin sửa đổi trên trang này không ảnh hưởng đến cấu hình ban đầu của đối tác',
  emptySopNodeWarning: 'Push node rỗng sẽ không thể đẩy tin nhắn một cách chính xác',
  AsynchronousLocking: 'Background đang tiến hành khóa không đồng bộ, sau đó có thể đi đến góc trên bên phải (tin nhắn) để xem kết quả',
  AsynchronousJobAccountVerify: 'Background đang được xử lý không đồng bộ, bạn có thể vào góc trên bên phải (tin nhắn) để xem kết quả sau.',
  RepeatClick: 'Hoạt động khóa đơn đang được thực hiện trong nền, đừng nhấp nhiều lần',
  RepeatClickJobAccountVerify: 'Hoạt động kiểm tra đang được thực hiện trong nền, đừng nhấp nhiều lần',
  RepeatClickJobAccountVerify2: 'Hủy kiểm tra đang được thực hiện trong nền, đừng nhấp nhiều lần',
  AddFromPartner: 'Thêm từ đối tác',
  AddManually: 'Thêm bằng tay',
  ReceivingMode: 'Cách nhận',
  PushNodeCannotBeEmpty: 'Push node không thể để trống!',
  PushBeEmptyPleaseCheck: 'Nút push không thể rỗng, hãy kiểm tra:',
  DetailedNumberOfCheckedGoods: 'Số lượng chi tiết hàng hóa được đánh dấu',
  NumberAssociatedPackingInformationPieces: 'Số lượng thông tin đóng gói liên quan',
  DetailedWeightOfGoodsChecked: 'Đánh dấu trọng lượng chi tiết của hàng hóa',
  AssociatedPackingInformationWeight: 'Thông tin đóng gói liên quan Trọng lượng',
  DetailedVolumeOfGoodsChecked: 'Khối lượng chi tiết của hàng hóa được đánh dấu',
  AssociatedPackingInformationVolume: 'Khối lượng thông tin đóng gói liên quan',
  CopyShippingMarkAndName: 'Sao chép từ nhãn hiệu ủy quyền',
  OperationCategory: 'Danh mục hoạt động',
  PleaseEnterTheBusinessNumber: 'Vui lòng nhập số doanh nghiệp.',
  NonExistent: 'Không tồn tại.',
  ContainerTip: 'Hộp này đã được liên kết với chi phí, vui lòng hủy liên kết trước khi thay đổi số hộp.',
  UploadCustomsDeclarationFile: 'Tải lên tập tin hải quan',
  UploadChargebackFile: 'Tải lên tập tin hoàn tiền',
  RevenueTypeCannotBeBlank: '【Loại thu và thanh toán】 Không thể để trống!',
  SettlementCompanyCannotBeBlank: '【Đơn vị thanh toán】 Không thể để trống!',
  IncorrectFormatOnlyIntegerSupported: 'Định dạng dữ liệu thuế suất không chính xác và chỉ hỗ trợ số nguyên!',
  domesticForeignCannotBeEmpty: '【Trong và ngoài nước】 Không thể để trống!',
  ImportResults: 'Nhập kết quả',
  AllSuccess: 'Tất cả thành công',
  AllFailed: 'Tất cả thất bại',
  PartialFailurePartialSuccess: 'Một phần thất bại, một phần thành công',
  OddNumbers: 'Số đơn',
  PleaseTheSameBusinessOperate: 'Vui lòng chọn cùng loại hình kinh doanh để hoạt động!',
  OperationError: 'Lỗi vận hành',
  NewBusiness: 'Doanh nghiệp mới',
  ThePleaseRefreshAndAgain: 'Hệ thống bận, vui lòng làm mới và thử lại',
  SubmittersRemarks: 'Ghi chú của tác giả',
  PleaseFillInTheRemarks: 'Vui lòng điền các ghi chú',
  YouAreNotTheSubmitter: 'Không phải người chủ trì cấp trên, không thể thao tác nghiệp vụ này!',
  PleaseFillInTheRemarksSigh: 'Vui lòng điền thông tin nhận xét!',
  PleaseEnterRemarks: 'Vui lòng nhập thông tin nhận xét!',
  TheTheCurrentOperationMaintenance: 'Hoạt động hiện tại không bảo trì người giám sát cấp trên, vui lòng gửi doanh nghiệp này sau khi bảo trì!',
  FailedForApprovalPleaseAgain: 'Gửi đánh giá cấp trên không thành công, vui lòng làm mới thử lại!',
  SubmittedSupervisorForApprovalSuccessfully: 'Gửi đánh giá giám sát thành công',
  ApprovedPass: 'Thẩm định đã đồng ý!',
  ApprovalRejected: 'Thẩm định đã từ chối!',
  Problem: 'Câu hỏi',
  Synchronized: 'Đồng bộ hóa',
  NotSynchronized: 'Chưa đồng bộ',
  YouToEditTheAdministrator: 'Bạn không có quyền chỉnh sửa dữ liệu tương ứng, vui lòng liên hệ với quản trị viên',
  SentOut: 'Đã đưa ra!',
  DefaultPSettlementID: 'Name',
  IsAREmpty: 'Các đối tượng cần nhận mặc định có trống không',
  IsAPEmpty: 'Đối tượng phải trả mặc định có rỗng hay không',
  TheFormCannotBeEmpty: 'Tờ khai hải quan không thể để trống!',
  ReminderOfTheCustomsData: 'Nhắc nhở: Trước khi tải lên tài liệu khai hải quan, vui lòng nhấp vào để xác định thông tin cần thiết để lưu tờ khai hải quan',
  ReminderOfTheCustomsPrint: 'Nhắc nhở: Dữ liệu sau đây sẽ không đẩy môi giới hải quan và chỉ được sử dụng để in các nguồn dữ liệu tài liệu',
  ObtainActualBusinessData: 'Lấy kinh doanh thực tế',
  TheToBeViewedAnyone: 'Các tập tin không cho phép bất cứ ai xem hoặc tải xuống.',
  YouPermissionToViewDownload: 'Bạn không có quyền xem hoặc tải xuống',
  File: 'Tài liệu',
  PleaseInTheSubmissionNotes: 'Vui lòng điền thông tin',
  ContainsInvoicesThatCannotBeModified: 'Chứa hóa đơn không thể sửa đổi',
  RemarksReviewedBy: 'Đánh giá',
  numberingRuleCannotBeEmpty: '【Quy tắc số】 Không thể để trống!',
  PortAreaDataComparison: 'So sánh dữ liệu cảng',
  ImportMode: 'Cách nhập',
  Keep: 'Giữ',
  Explain: 'Mô tả:',
  BlackIsTheInputData: 'Đen để nhập dữ liệu.',
  BlueThePortAreaData: 'Màu xanh là dữ liệu khu cảng,',
  GrayIsPreEnteredData: 'Màu xám cho dữ liệu nhập trước',
  UpdatedToPortAreaData: 'Cập nhật dữ liệu cảng',
  lclCompareHarbourTips1: '1. Mặc định ghi đè tất cả ("dữ liệu của khu vực cảng" ghi đè tất cả "nhập hệ thống" dữ liệu), không đánh dấu để chỉ ra rằng dữ liệu hệ thống được giữ lại, dữ liệu khu vực cảng không được ghi đè; Bỏ chọn tất cả, giữ lại dữ liệu hệ thống gốc',
  lclCompareHarbourTips2: 'Màu đỏ cho thấy thông tin không phù hợp với "dữ liệu hệ thống" và "dữ liệu cảng".',
  lclCompareHarbourTips3: 'Vui lòng xác nhận thông tin đóng gói chính xác càng sớm càng tốt, nó sẽ ảnh hưởng đến SOP tiếp theo và hiển thị đẩy thông tin cảnh báo hàng hóa',
  UpdatedData: 'Cập nhật dữ liệu',
  compareHarbourTips1: 'B5-03=giá trị thông số Ki, (cài 3)',
  compareHarbourTips2: '2. Nhấp vào số hộp để chuyển đổi để xem thông tin, màu đỏ cho biết thông tin không phù hợp với "dữ liệu hệ thống" và "dữ liệu cảng"',
  compareHarbourTips3: 'Nếu không đánh dấu vào 【Khác】, thì "dữ liệu hệ thống" vẫn giữ nguyên dữ liệu đóng gói ban đầu, "dữ liệu cảng" sẽ không thêm thông tin đóng gói; Không đánh dấu vào 【Số hộp】 tương ứng, giữ lại "dữ liệu hệ thống"; Bỏ chọn tất cả, giữ lại dữ liệu hệ thống gốc',
  compareHarbourTips4: 'Vui lòng xác nhận thông tin đóng gói chính xác càng sớm càng tốt, nó sẽ ảnh hưởng đến SOP tiếp theo và hiển thị đẩy thông tin cảnh báo hàng hóa',
  SystemEntry: 'Nhập hệ thống',
  PortAreaData: 'Dữ liệu cảng',
  ImportDescriptions: 'Các loại nhập khẩu là sửa đổi, các hệ thống lần lượt phù hợp với dữ liệu nhất trí với cảng theo số hộp, loại hộp, loại hộp. Loại nhập được thêm vào để hệ thống không tìm thấy dữ liệu phù hợp với dữ liệu cảng. Loại nhập là giữ, dữ liệu nhập cho bạn không khớp với dữ liệu cảng, tức là dữ liệu nhập ban đầu cho bạn.',
  WhenTheBoxIsIdentifiedAsABox: 'Khi đánh dấu hộp là hộp, không hiển thị số đóng cửa, số liệu của bộ lông là tổng số hàng hóa.',
  ClickEnteredDataPleaseOperation: 'Nhấp vào 【Cập nhật dữ liệu cảng】, hệ thống sẽ dựa trên thông tin đã được đánh dấu cập nhật hệ thống nhập dữ liệu thành dữ liệu cảng, đồng thời màu chữ sẽ chuyển sang màu đen, xin vui lòng xác nhận dữ liệu cảng là chính xác sau đó hoạt động.',
  Determine: 'Xác định',
  Cancel2: 'Hủy bỏ',
  PleaseAtLeastOneRecord: 'Vui lòng chọn ít nhất một bản ghi!',
  Hello: 'Xin chào',
  EnclosedPleaseFind: 'Vui lòng kiểm tra và nhận',
  PhotosOf: 'Ảnh chụp',
  ThankYou: 'Cảm ơn.',
  TheAndFreightTermsBlank: 'Tên tàu mới được chọn, công ty tàu, đơn hàng chính, đại lý thay đổi đơn hàng, ngày khởi hành, ngày dự kiến đến cảng, ngày thực tế đến cảng, kho, phương thức đặt hàng chính và điều khoản vận chuyển đơn hàng chính không phù hợp với vé chính; Hoặc hóa đơn hải quan nhỏ là trống không.',
  TheModifyTheSmallContinue: 'Hệ thống sẽ thay đổi hóa đơn nhỏ. Tiếp tục không?',
  SaveFailedSigh: 'Cứu thất bại!',
  CellPhoneNumber2: 'Số điện thoại',
  NoSopNodeMatched: 'Các nút không khớp với doanh nghiệp hiện tại của bạn, hãy chọn lại',
  NameCannotBeEmpty: 'Tên không được để trống!',
  PleaseSelectARecord2: 'Vui lòng chọn một bản ghi.',
  ChangePassword: 'Thay đổi mật khẩu',
  OriginalPassword: 'Mật khẩu gốc',
  NewPassword: 'Mật khẩu mới',
  ConfirmPassword: 'Xác nhận mật khẩu',
  ModificationPleaseLogInAgain: 'Thay đổi thành công, vui lòng đăng nhập lại',
  TheEnteredTwiceAreInconsistent: 'Mật khẩu nhập hai lần không phù hợp',
  DearUser: 'Người dùng thân mến:',
  ItSystemInOrderMode: 'Theo dõi rằng chế độ trình duyệt hiện tại của bạn là chế độ tương thích ảnh hưởng đến tốc độ hoạt động của hệ thống CargoWare, để tăng tốc độ và hiệu quả hoạt động của hệ thống, hãy chuyển sang chế độ cực nhanh.',
  TheShownInTheBelow: 'Hoạt động cụ thể như hình dưới đây:',
  ToSwitchTutorialsSee: 'Chuyển hướng dẫn xin vui lòng xem:',
  GotIt: 'Hiểu rồi.',
  FullScreen: 'Toàn màn hình',
  EarlyWarningReminder: 'Cảnh báo sớm',
  AnnouncementMessage: 'Thông báo',
  Cancellation: 'Đăng xuất',
  FlagshipEdition: 'Phiên bản Flagship',
  BasicEdition: 'Phiên bản cơ bản',
  TrialCustomers: 'Khách hàng dùng thử',
  FormalCustomer: 'Khách hàng chính thức',
  SystemAdministrator: 'Quản trị hệ thống',
  RefreshCacheMethod: 'Phương thức làm mới bộ nhớ cache',
  AfterTheCorrespondingCacheData: 'Sau khi bạn hoàn thành việc duy trì dữ liệu cơ bản, hãy cập nhật bộ nhớ cache thích hợp để có được dữ liệu mới nhất.',
  ViewCacheRefreshMethod: 'Xem phương pháp làm mới bộ nhớ cache',
  PleaseExitTheEditingModule: 'Trước tiên, hãy lưu dữ liệu đã thay đổi hoặc thoát khỏi trạng thái chỉnh sửa, sau đó đóng mô-đun.',
  SessionPleaseLogInAgain: 'Thời gian chờ phiên, vui lòng hạ cánh lại',
  EDITemplateExceptionDownloadFailed: 'Mẫu edi bất thường, tải xuống thất bại...',
  One: 'Một',
  Two: 'Hai',
  Three: 'Ba',
  Four: 'Bốn.',
  Five: 'Năm.',
  Six: 'Sáu',
  Just: 'Vừa mới',
  MinutesAgo: 'Vài phút trước',
  HoursAgo: 'giờ trước',
  OneDayAgo: '1 ngày trước',
  LastWeek: 'Tuần trước',
  LastMonth: 'Tháng trước',
  LastThreeMonths: 'Ba tháng qua',
  PleaseSelectDataFirst: 'Vui lòng chọn dữ liệu trước',
  SelfBooking: 'Cabin tự đặt',
  CommissionedBooking: 'Đặt phòng',
  CustomerSelfBooking: 'Cabin khách hàng',
  OwnContractPrice: 'Giá giao ước riêng',
  CustomerOffer: 'Khách hàng về giá',
  OverseasAgentContractPrice: 'Giá đại lý ở nước ngoài',
  UncommittedPrice: 'Không có giá hẹn',
  PeerAgreementPrice: 'Giá đồng hành',
  BuyerLCL: 'Hộp buyer',
  InnerPacking: 'hộp bên trong,',
  DoorPointPacking: 'đóng hộp điểm cửa,',
  SelfPullingAndSelfSending: 'Tự kéo tự đưa,',
  DeclareAtCustoms: 'Khai hải quan,',
  Fumigation: 'Khử trùng,',
  CommodityInspection: 'Kiểm tra thương mại,',
  BookingSpace: 'Đặt khoang.',
  SetSpell: 'Bộ ghép',
  PersonalBelongings: 'Vật dụng cá nhân',
  OneMasterAndManyPoints: 'Một chủ nhiều điểm',
  OneMasterAndOneMinute: 'Một chủ một điểm',
  UnknownType: 'Kiểu Không rõ',
  Marked: 'Đã gắn thẻ',
  Unmark: 'Chưa gắn thẻ',
  PendingOrder: 'Đặt hàng',
  OrderPlaced: 'Đặt hàng',
  ReceivedOrder: 'Đã nhận hóa đơn',
  NotIssued: 'Chưa cấp',
  Issued: 'Đã cấp',
  Retrieved: 'Đã lấy lại',
  Accepted: 'Đã nhận',
  Claimed: 'Đã nhận',
  ChangeOrder: 'Thay đổi danh sách',
  ApprovedBusinessCannotBeEdited: 'Các doanh nghiệp đã được xem xét không thể được chỉnh sửa.',
  OrderAlreadyApproved: 'Đơn hàng {0} đã được duyệt.',
  YouPermissionToEditNotes: 'Bạn không có quyền chỉnh sửa phiếu.',
  EnglishNameOfHBLConsignee: 'HBL Cargo Receiver Tên tiếng Anh',
  EnglishNameOfHBLShipper: 'HBL Shipper Tên tiếng Anh',
  AgentNetworkCustomerService: 'Hỗ trợ mạng đại lý',
  ReImportAfterModification: 'Có thể nhập lại sau khi sửa đổi',
  DownloadFailedData: 'Tải xuống dữ liệu thất bại',
  TheCaseOfMultipleFirst: 'Gia hạn thời gian không đề nghị sử dụng trong tình huống nhiều lựa chọn, trước tiên kiểm tra xem có tồn tại đánh dấu dư thừa hay không!',
  InvalidNumberEntered: 'Nhập số không hợp lệ!',
  TheOrThePartnerSigned: 'Khách hàng đã đăng ký hoặc đối tác đã đăng ký!',
  FirstDateCannotBeBlank: 'Ngày liên lạc đầu tiên không được để trống!',
  PleaseInTheTelephoneNumber: 'Vui lòng điền vào số điện thoại!',
  PleaseRemoveTheTicketFirst: 'Vui lòng xóa vé trước',
  ExpenseHasBeenEntered: 'Chi phí đã được ghi nhận.',
  ConsolidationHasBeenDone: 'Đã làm và đơn',
  Save: 'Cứu hay không?',
  PleaseEnterCurrencyExchangeRate: 'Vui lòng nhập tỷ giá hối đoái',
  FailedOpenSalesQueryDetails: 'Truy vấn bán hàng chi tiết mở thất bại!',
  pleaseEnterTemplateName: 'Vui lòng nhập tên mẫu',
  blank: 'Khoảng trắng',
  PartnersBeenAddedToBlacklist: 'Đối tác đã bị thêm vào danh sách đen!',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: 'Khách hàng này cho khách hàng rủi ro hãy cẩn thận {0} động đơn đặt hàng',
  AlreadyExistsOverwriteOriginalScheme: 'Tên chương trình đã tồn tại, có ghi đè lên chương trình ban đầu không?',
  NoDataToSave: 'Không có dữ liệu để lưu',
  ColumnSettings: 'Thiết lập cột',
  CurrentPage: 'Trang hiện tại',
  CurrentSelection: 'Chọn hiện thời',
  NoModificationAllowedAfterBusinessSubmission: 'Việc sửa đổi sẽ không được phép sau khi nộp đơn, vui lòng xác nhận xem các tài liệu liên quan đã được tải lên chưa trước khi nộp',
  AboutToUploadFiles: 'Upload tập tin sắp tới',
  SuccessfullyUploaded: 'Upload thành công',
  RetrievalOfAssignedPermissions: 'Truy xuất quyền được gán',
  UploadResults: 'Upload kết quả',
  OnlyFilesFormatCanUploaded: 'Chỉ có thể tải lên các tập tin có định dạng {0}',
  VolumeAbnormalAndCannotUploaded: 'Kích thước tập tin bất thường, không thể tải lên.',
  VolumeExceeds5mAndCannotUploaded: 'Dung lượng tập tin lớn hơn 5M, không thể tải lên.',
  VolumeExceeds20mAndCannotUploaded: 'Dung lượng tập tin lớn hơn 20M, không thể tải lên.',
  PlaceOfDeliverySeaport: 'Nơi giao hàng (cảng biển)',
  PlaceOfDeliveryAirport: 'Nơi giao hàng (cảng hàng không)',
  SailingDay: 'Ngày khởi hành',
  BusinessCreationDate: 'Ngày thành lập doanh nghiệp',
  DeliveryStation: 'Trạm giao hàng',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: 'Không có giấy tờ nào được truy vấn và có thể đang được khai báo hoặc không sử dụng cá nhà táng.',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: 'Các kiểu hộp này đã liên kết với thông tin niêm phong hộp, bạn có đồng bộ thay đổi các kiểu hộp trang thông tin đóng góp không?',
  SeaEqAsyncToContainerTip: 'Bạn đã nhập thông tin niêm phong hộp liên quan, xin vui lòng xóa bỏ thông tin niêm phong hộp trước!',
  TheSynchronizedFileCannotBeEdited: 'Tập tin đồng bộ không thể sửa',
  TheSynchronizedFileIsNotDeleted: 'Tập tin đã đồng bộ không thể xóa',
  CurrentBusinessStatusCannotBeSynchronized: 'Tình trạng kinh doanh hiện tại không thể đồng bộ',
  TheSynchronizedExpensesCannotBeDeleted: 'Không thể xóa phí đồng bộ, vui lòng hủy bỏ phí đồng bộ trước.',
  CurrentlyThereIsNoSynchronizationCosts: 'Hiện tại không có phí đồng bộ',
  ThereAreCurrentlyNoCancellableCharges: 'Hiện tại không có phí hủy bỏ',
  NoCurrentChargesCanBeCancelled: 'Hiện tại không có phí đồng bộ hủy bỏ',
  ChargeItemChangeTip: 'Tên chi phí này Thông tin thanh toán mặc định không phù hợp với chi phí hiện tại, có được cập nhật không?',
  SubscriptionInformation: 'Thiết lập công ty (chi nhánh) mà bạn muốn nhận thông tin đăng ký',
  SetUpThePartners: 'Thiết lập đối tác bạn cần đăng ký',
  PleaseSelectAInformation: 'Vui lòng chọn thông tin giá.',
  ThisRateHasExpired: 'Giá vận chuyển này đã hết hạn!',
  ExternalUsersCannotEdit: 'Người dùng bên ngoài không thể hiệu chỉnh, xin vui lòng vào trang người dùng thương mại điện tử đối tác.',
  CommunicationConfirmation: 'Trong thời hạn vận chuyển có hiệu lực không tìm thấy ngày khởi hành phù hợp với yêu cầu của thời hạn tàu, xin vui lòng liên lạc xác nhận với bên đặt khoang!',
  CombineTips: 'Không thể chọn vé chính để kết hợp!',
  RepeatMblForSave: 'Số đơn chính lặp lại, có xác nhận lưu không?',
  SystemAlert: 'Nhắc nhở hệ thống',
  NotRepeatOperation: 'Trạng thái đã thay đổi, đừng lặp lại thao tác.',
  FeesHaveBeenUsedForEditUnit: 'Đã có chi phí sử dụng cho mã đơn vị này, không thể sửa đổi!',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: 'Đã có phương án chi phí sử dụng mã đơn vị thanh toán này, không thể sửa đổi!',
  ApplyChangeChargeNotThrough: 'Đã {0}, không thể {1}, vui lòng đánh dấu lại.',
  KingdeeNotExist: 'Dữ liệu không cần đồng bộ hóa hoặc hệ thống bướm vàng không tồn tại',
  ByAdjustmentDate: 'Theo ngày điều chỉnh',
  ByBusinessDate: 'Theo ngày kinh doanh',
  PleaseEnterTheFileType: 'Vui lòng nhập loại tập tin',
  NotExportToImportBusiness: 'Đơn hàng này không phải là nghiệp vụ xuất khẩu chuyển nhập khẩu, không thể đồng bộ!',
  JobNotOperateStatus: 'Đơn này không phải trạng thái thao tác chính, không thể đồng bộ!',
  JobShutOut: 'Đơn hàng này đã hoàn quan, không thể đồng bộ!',
  ChargeSyncSuccess: 'Chi phí đồng bộ thành công!',
  NoSynchronizedFees: 'Không có chi phí đồng bộ!',
  SaveColumnSettingsSameTime: 'Lưu các thiết lập cột hiện hành cùng một lúc',
  SaveScheme: 'Sơ đồ lưu',
  ReceivableCharge: 'Phải thu (phí)',
  PayableCharge: 'Phải trả (chi phí)',
  TruckingNotExist: 'Làm hộp thông tin không tồn tại!',
  SaveDisplayColumns: 'Lưu cột hiển thị',
  NoPermissionToAddExpense: 'Không có phí Thêm quyền',
  NoPayableAddPermissionCannotImported: 'Bạn không có quyền phải trả phí mới, không có phí nhập khẩu',
  NoPayableAddPermissionOnlyImportReceivable: 'Bạn không có quyền phải trả phí mới, chỉ nhập phí phải trả',
  NoReceivableAddPermissionCannotImported: 'Bạn không có quyền mới để tính phí, không có phí nhập khẩu',
  NoReceivableAddPermissionOnlyImportPayable: 'Bạn không có quyền mới để tính phí, chỉ nhập các khoản phí phải trả',
  OnlyRejectedBusinessesCanDelete: 'Chỉ xóa các doanh nghiệp bị từ chối',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: 'Chỉ có thể xóa các doanh nghiệp bị từ chối và các doanh nghiệp khác bị bỏ qua',
  SuccessfullySubmittedXBusiness: 'Điều {num} đã được đệ trình thành công',
  SuccessfullySubmittedXBusinessOtherIgnore: 'Điều khoản {số} đã được đệ trình thành công và trạng thái sơ thẩm của doanh nghiệp còn lại không đáp ứng điều kiện đệ trình',
  SuccessfullyRevokedXBusiness: 'Đã rút thành công {num} điều khoản kinh doanh',
  SuccessfullyRevokedXBusinessOtherIgnore: 'Điều khoản {số} của doanh nghiệp đã được rút thành công và trạng thái sơ thẩm của doanh nghiệp còn lại không đáp ứng điều kiện rút tiền',
  SuccessfullyConvertRealXBusiness: 'Đã chuyển giao thành công dịch vụ chính thức',
  SuccessfullyConvertRealXBusinessOtherIgnore: 'Đã chuyển giao thành công nghiệp vụ chính thức {số} điều kiện, các nghiệp vụ còn lại chưa đáp ứng điều kiện chuyển giao nghiệp vụ chính thức',
  ChargeSyncJobStateCheckFail: 'Kiểm tra trạng thái kinh doanh đồng bộ hóa chi phí không vượt qua',
  HaveChargeNotAllocatedAndtoContinue: 'Có chi phí chưa chia sẻ, xin xác nhận có tiếp tục đồng bộ chi phí hay không?',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: 'Đối tác đã tồn tại, vui lòng chọn trong số khách hàng chính thức',
  PartnerHasMaintainedUndeToContinue: 'Đối tác này đã được duy trì theo 【{officeCode}】, bạn có tiếp tục tạo không?',
  fileManagement: 'Quản lý tập tin',
  FilterValue: 'Giá trị lọc',
  PriceAndNumIsNull: 'Đơn giá, số lượng là trống, tiếp tục?',
  SyncContainerSealNoToBillOfLading: 'Cập nhật đồng bộ số đóng gói B/L',
  AssociatedBillOfLadingCannotDelete: 'Vận đơn liên kết, không thể xóa',
  AssociatedBillOfLadingCannotRemove: 'Vận đơn liên kết, không thể tháo rời',
  SettlementObjectAccountPeriod: 'Thời hạn thanh toán đối tượng',
  SettlementObjectAccountCredit: 'Hạn mức tín dụng đối tượng thanh toán',
  InvoiceHeaderDifferent: 'Hóa đơn ngẩng đầu không nhất trí, có tiếp tục hay không?',
  Agreement: 'Thống nhất',
  NotAgreement: 'Không phù hợp',
  AllocationNature: 'Phân chia tài sản',
  VirtualAllocation: 'Chia sẻ ảo',
  ActualSplit: 'Chia thật',
  ShareTypeTip: 'Nhất quán: Tất cả các loại chi phí được chia đều nhất quán, sửa đổi loại chi phí được chia đều, các loại chi phí khác được thay đổi thành nhất quán n không nhất quán: loại chi phí được chia đều có thể không nhất quán, chỉ thay đổi loại chi phí hiện tại khi thay đổi loại chi phí được chia sẻ',
  VirtualAllocationAndActualSplitTip: 'Chia sẻ ảo: Trong hóa đơn chính tiến hành thanh toán hóa đơn, lập hóa đơn, yêu cầu thanh toán, thanh toán hóa đơn, v.v. Chi phí chia sẻ đến hóa đơn nhỏ là ảo, chỉ có thể xem xét, không thực hiện thanh toán thực chất. Phân chia thực tế: Chi phí sau khi chia sẽ sẽ được thanh toán trên hóa đơn, hóa đơn, yêu cầu thanh toán, thanh toán, v.v. Nếu chi phí của hóa đơn chính đã được thanh toán thì không thể phân chia chi phí thành hóa đơn nhỏ.',
  ActualSplitWarn: 'Chú ý: Sau khi chia tay thật, không giữ lại chi phí ban đầu của đơn hàng chính và không thể hoàn nguyên, xin hãy cẩn thận thao tác!',
  CannotActualSplitTip: 'Chi phí xây dựng hóa đơn chính, khai hóa đơn, xin thanh toán, tiêu thụ hóa đơn v. v...... sau khi thanh toán không thể phân chia chi phí đến hóa đơn nhỏ!',
  SharedChargeTotal: 'Tổng chi phí chia sẻ',
  DataHadUpdated: 'Dữ liệu đã được sửa đổi, vui lòng thử lại sau khi truy vấn lại',
  OpenSOPPanelNeedDoubleClick: 'Để mở bảng SOP, bạn có thể nhấp đúp vào trạng thái nghiệp vụ để gợi lại.',
  Operator: 'Nhân viên vận hành',
  HaveInHand: 'Đang tiến hành',
  Exception: 'Bất thường',
  TerminalCompany: 'Công ty Dock',
  TerminalLocation: 'Công ty Dock',
  DeliveryAddress: 'Địa chỉ nhận hàng',
  TerminalAddress: 'Địa chỉ nhận hàng',
  TcDeliveryAddress: 'Thông tin địa chỉ nhận hàng của công ty bến tàu',
  ResultLogUploadFaild: 'Kết quả tải lên nhật ký lưu trữ đám mây không thành công, vui lòng thử lại!',
  ConfigureDisplayColumns: 'Cấu hình các cột hiển thị',
  AllNames: 'Tất cả tên',
  SelectedColumns: 'Cột đã chọn',
  NoPermissionViewSecondaryTable: 'Bạn không có quyền xem thông tin bảng cấp hai!',
  NoPermissionSetSecondaryTableColumns: 'Bạn không có quyền thiết lập cột hiển thị bảng cấp hai!',
  UpdateNoticeDetails: 'Thông báo cập nhật 【Chi tiết】',
  DontRemindMeAgain: 'Lần sau đừng nhắc nữa.',
  NewInnerContractNo: 'Tạo mới Internal Approach',
  EditInnerContractNo: 'Sửa đổi Internal Approx',
  AreYouSureToCancelThisData: 'Xác nhận hủy bỏ dữ liệu này?',
  HasBeenUsedAndCannotEditContractNo: 'Đã được sử dụng, không thể chỉnh sửa số giao ước',
  HasBeenUsedAndCannotBeDeleted: 'Đã được sử dụng, không thể xóa',
  ApplicableRoute: 'Đường bay áp dụng',
  IsEnable: 'Bật hay không',
  ContractNoUseState: 'Trạng thái sử dụng Approx',
  NotUse: 'Không sử dụng',
  Occupies: 'Việt',
  DataLoadingFailed: 'Tải dữ liệu không thành công...',
  ExportExcel: 'Xuất Excel',
  ExportExcel2: 'Xuất Excel',
  ExportPDF: 'Xuất PDF',
  ExportWord: 'Xuất Word',
  ExportPPT: 'Xuất PPT',
  NoDataIsCurrentlySelected: 'Hiện chưa chọn dữ liệu',
  SelectAll: 'Chọn tất cả',
  CustomerSelfIssue: 'Khách hàng tự đặt hàng',
  Clear: 'Xoá',
  QuickOfLadingNumberCustomsNumber: 'Truy cập nhanh: Số doanh nghiệp/Số vận đơn/Số đơn hàng tắt',
  QuickMnemonicabbreviationChineseAndEnglishNames: 'Truy cập nhanh: Mã trợ giúp/Viết tắt/Tên tiếng Anh',
  InvoiceNumber: '/Số hóa đơn',
  BusinessNumber: '/Số doanh nghiệp',
  BillingNumber: '/Số hóa đơn',
  PaymentApplicationNumber: '/Số yêu cầu thanh toán',
  VerificationNumber: '/Số pin hạt nhân',
  ReconciliationNumber: '/Số đối chiếu',
  ActualPaymentAndReceiptNumber: '/Số tiền trả thật',
  DeliveryOrderNumber: '/Đặt số đơn',
  ProgramNumber: '/Số chương trình',
  QuickSearch: 'Truy xuất nhanh',
  SearchBeRemovedNotFound: 'Không tìm thấy searchItem cần loại bỏ',
  Error3: 'Lỗi',
  AdvancedSchemeLoadingFailed01: 'Bộ cấu hình truy vấn nâng cao tải không thành công 01=:',
  TheFoundPleaseSelectScheme: 'Không tìm thấy chương trình, vui lòng chọn chương trình khác',
  AreYouWantToDelete: 'Bạn chắc chắn muốn xóa?',
  Tip: 'Mẹo',
  DeleteSchemeFailed: 'Bộ gỡ bỏ không thành công:',
  N1Exceeds4MBCannotUploaded: '1 tệp có dung lượng lớn hơn 4MB và không thể tải lên.',
  N1Exceeds20MBCannotUploaded: '1 tệp có dung lượng lớn hơn 20MB và không thể tải lên.',
  DeleteFileFailed: 'Xóa tập tin không thành công!',
  Edit: 'Chỉnh sửa',
  SelectFile: 'Chọn tập tin',
  DeleteFile: 'Xoá tập tin',
  Upload: 'Tải lên',
  UploadFile: 'Tải lên tập tin',
  FileName: 'Tên tập tin',
  FileType: 'Kiểu tập tin',
  FileSize: 'Cỡ tập tin',
  Uploader: 'Tải lên',
  UploadTime: 'Thời gian tải lên',
  UploadProgress: 'Tiến trình tải lên',
  Uploading2: 'Đang tải lên......',
  WaitingForUpload: 'Chờ upload',
  DocumentCategory: 'Danh mục tài liệu',
  PlatformCustomerService: 'Hỗ trợ nền tảng',
  Yes: 'Vâng',
  No: 'Không',
  Confirm: 'Xác nhận',
  SaveColumnStatus: 'Lưu trạng thái cột',
  ResetColumnStatus: 'Đặt lại trạng thái cột',
  SaveColumnStatusSuccess: 'Lưu trạng thái cột thành công',
  SaveColumnStatusFailed: 'Lưu trạng thái cột không thành công',
  ResetColumnStatusSuccess: 'Đặt lại trạng thái cột thành công',
  ChatWindow: 'Cửa sổ chat',
  Internal: 'Nội thất',
  Communication: 'Giao tiếp',
  InternalCommunication: 'Truyền thông nội bộ',
  ExternalCommunication: 'Giao tiếp bên ngoài',
  Customer: 'Khách hàng',
  Reset: 'Đặt lại',
  Search: 'Tìm kiếm',
  CurrentlySelectedItem: 'Chọn hiện thời:',
  Port: 'Cảng',
  State: 'Quốc gia',
  FileAbnormalCannotBeUploaded: 'Kích thước tập tin bất thường, không thể tải lên.',
  File20MCannotBeUploaded: 'Dung lượng tập tin lớn hơn 20M, không thể tải lên.',
  UploadSuccessful: 'Upload thành công',
  ImportFile: 'Nhập tập tin',
  PrintTemplate: 'Mẫu in:',
  Code: 'Mã số',
  ChineseName: 'Tên Trung Quốc',
  EnglishName: 'Tên tiếng Anh',
  Country: 'Quốc gia',
  Region: 'Khu vực',
  Name2: 'Tên',
  StartDate: 'Ngày bắt đầu',
  To: 'Đến',
  EndDate: 'Ngày kết thúc',
  CurrentAuthorizations: 'Quyền sở hữu hiện tại',
  Refresh: 'Làm mới',
  User: 'Người dùng:',
  Authorization: 'Giấy phép',
  Time: 'Thời gian:',
  AuthorizationUseHistory: 'Lịch sử sử dụng ủy quyền:',
  AuthorizationFailed: 'Lỗi ủy quyền',
  SendTest: 'Gửi thử nghiệm',
  CurrentPersonalAuthorizationList: 'Danh sách ủy quyền cá nhân hiện tại',
  SendTo: 'Gửi đến:',
  Confirm2: 'Xác định',
  Cancel: 'Hủy bỏ',
  Close: 'Đóng cửa',
  Open: 'Mở',
  AuthorizationItemDescription: 'Mô tả mục ủy quyền',
  AuthorizationItem: 'Mục ủy quyền',
  AuthorizationStatus: 'Tình trạng ủy quyền',
  NotSet: 'Chưa đặt',
  StatusChangeTime: 'Thời gian thay đổi trạng thái',
  Operation: 'Hoạt động',
  PleaseAddProductDescriptionHere: 'Vui lòng thêm mô tả sản phẩm tại đây',
  WeChatMessagePush: 'Tin nhắn WeChat đẩy',
  MarqueeSwitch: 'Công tắc đèn chạy',
  PleaseInEmailPasswordauthorizationCode: 'Vui lòng điền mật khẩu hộp thư/mã ủy quyền!',
  PleaseFillInRecipientEmail: 'Vui lòng điền vào hộp thư nhận!',
  EmailSettingsTestEmail: 'Thiết lập hộp thư - Kiểm tra thư',
  SendSuccessfully: 'Gửi thành công',
  PaymentUponReceipt: 'Xem hóa đơn thanh toán',
  All: 'Tất cả',
  Unread: 'Chưa đọc',
  Read: 'Đã đọc',
  MMDDDayHHMm: 'Ngày DD tháng HH: mm',
  AssignSales: 'Phân phối bán hàng',
  ReleaseSales: 'Giải phóng bán hàng',
  ReviewSales: 'Kiểm toán bán hàng',
  SuccessfullyGrabCustomer: 'Cướp khách hàng thành công',
  GrabCustomerFailed: 'Cướp khách hàng thất bại',
  ScheduleReminder: 'Lịch trình nhắc nhở',
  CustomerExpirationReminder: 'Khách hàng hết hạn nhắc nhở',
  BusinessReviewReminder: 'Nhắc nhở kiểm toán doanh nghiệp',
  CustomsDeclarationReminder: 'Thông báo hải quan',
  AbnormalHandlingOfBox: 'Hộp xử lý bất thường',
  DeparturePickUpContainerWarning: 'Báo động khởi hành.',
  BoxArrivingAtFactoryWarning: 'Hộp đến nhà máy cảnh báo sớm',
  BoxLeavingFactoryWarning: 'Hộp cảnh báo rời nhà máy',
  CustomsReleaseWarning: 'Cảnh báo hải quan',
  TerminalReleaseWarning: 'Cảng báo động',
  BoardingWarning: 'Lên tàu cảnh báo sớm',
  DepartureWarning: 'Cảnh báo khởi hành',
  ArrivalWarning: 'Cảnh báo cảng',
  ReturningBoxWarning: 'Hộp cảnh báo sớm',
  SystemArrearsReminder: 'Hệ thống nợ nhắc nhở',
  ChangeReviewAndApprovalReminder: 'Thay đổi lời nhắc phê duyệt kiểm tra chi phí',
  DefaultMessage: 'Thông điệp mặc định',
  Message: 'Thông điệp hệ thống',
  SelectTemplate: 'Chọn mẫu',
  PleaseSelectTheExportTemplate: 'Vui lòng chọn mẫu xuất',
  Upload0UploadFailure0: 'Tải lên thành công: {0} tải lên thất bại: {1} tải lên.',
  SuccessfulFailure0ConfirmSave: 'Tải lên thành công: {0} Không thành công: {1} Xác nhận bạn muốn lưu?',
  Only0FormatCanUploaded: 'Chỉ có thể tải lên các tập tin có định dạng {0}',
  YouToOpenTheModule: 'Bạn không có quyền mở mô-đun 【{0}】',
  Upload0UploadFailed0: 'Tải lên thành công: {0} tải lên thất bại: {1} tải lên.',
  All2: '(Tất cả)',
  NumberOfPiecescommissionactual: 'Số kiện (ủy ban)',
  LetterOfCreditTerms: 'Điều khoản L/C',
  N4InsuranceCompletion: '4 Bảo hiểm hoàn thành',
  N2Inquiry: '2 Yêu cầu',
  SensitiveWords: 'Từ nhạy cảm',
  FreightRateDetails: 'Chi tiết vận chuyển',
  Manufacturer: 'Nhà sản xuất',
  ShipName: 'Tên tàu:',
  IsItCorrect: 'Đúng hay không.',
  BoxReturnedFromTheArea: 'Thông tin hàng hóa trả về từ cảng:',
  CurrentlyStatusAndCannotDeleted: 'Hiện đang chỉnh sửa, không thể xóa',
  ChineseAbbreviationOfTheCompany: 'Tên gọi tắt tiếng Trung của công ty:',
  TheTheCompanyCannotEmpty: 'Tiếng Anh không thể để trống',
  Voyage: 'Hành trình:',
  ShippingSchedule: 'Ngày tàu:',
  PortOfDepartureUpdate: 'Cập nhật cảng khởi hành',
  DestinationPortUpdate: 'Cập nhật cảng đích',
  ChatInside: 'Truyền thông nội bộ',
  ChatByClient: 'Giao tiếp bên ngoài',
  DoubleClickToSelectState: 'Nhấp đúp vào hộp văn bản để chọn truy vấn trạng thái',
  StateQuery: 'Truy vấn trạng thái',
  EdiStateQuery: 'Truy vấn trạng thái EDI',
  BookingEdiSendType: 'Kênh EDI',
  BookingEdiSendTime: 'Thời gian EDI',
  imConnecting: 'Đang cố gắng kết nối......',
  imConnectFailed: 'Kết nối phiên chạy không thành công, vui lòng mở lại sau khi đóng.',
  SwitchBranchAndOpenModuleTipAllEdit: 'Vui lòng lưu dữ liệu và đóng các mô-đun đã mở trước khi chuyển chi nhánh, hiện đang mở {0} mô-đun, bạn có đóng tất cả các mô-đun không?',
  SwitchBranchAndOpenModuleTipNotEdit: 'Vui lòng đóng các mô-đun đã mở trước khi chuyển chi nhánh, hiện đang mở {0} mô-đun, bạn có đóng tất cả không?',
  SwitchBranchAndOpenModuleTipPartEdit: 'Vui lòng lưu dữ liệu và đóng mô-đun trước khi chuyển đổi chi nhánh, các mô-đun {0} hiện đang mở chưa được lưu và đóng, có phải tất cả đều đóng không?',
  PrintRecordsOverLimitTip: 'Số lượng bản ghi in vượt quá giới hạn trên của hệ thống, có được xuất trực tiếp không?',
  PrintRecordsOver100Tip: 'In hơn 100 bản ghi và thời gian tải có thể dài hơn, bạn có xuất trực tiếp không?',
  ContinuePreview: 'Tiếp tục xem thử',
  NotSupported: 'Không hỗ trợ {0} hiển thị nối dữ liệu đa chiều',
  PleaseFillInCorrectly: 'Vui lòng điền chính xác thông tin đa chiều, không cho phép trống ở giữa',
  DoNotEmpty: 'Không được để trống dữ liệu.',
  AirlineReplacement: 'Một sự thay đổi trong bộ phận chuyến bay sẽ làm trống thông tin sân bay tại cảng khởi hành (sân bay, thời gian nhập cảnh thực tế, thời gian xếp hàng thực tế, thời gian cất cánh dự kiến, thời gian cất cánh thực tế) và lấy lại dữ liệu',
  AirlineReplacement1: '1. Các hãng hàng không sửa đổi không có trong danh sách các hãng hàng không được hỗ trợ đăng ký và sẽ không thể lấy dữ liệu',
  AirlineReplacement2: '2. Một sự thay đổi trong bộ phận hàng không một chiều sẽ làm trống thông tin sân bay cảng khởi hành (sân bay, thời gian nhập cảnh thực tế, thời gian tải thực tế, thời gian cất cánh dự kiến, thời gian cất cánh thực tế)',
  AirlineReplacementLast: 'Chuyến bay cuối cùng đã thay đổi để làm trống thông tin sân bay của cảng đích (thời gian đến dự kiến, thời gian đến thực tế, thời gian nhận hàng thực tế, thời gian dỡ hàng thực tế, thời gian thông báo đến thực tế, thời gian nhận hàng thực tế) và lấy lại dữ liệu',
  AirlineReplacementLast2: '2. Bộ phận hàng không cuối cùng đã thay đổi để làm trống thông tin sân bay tại cảng đích (thời gian đến dự kiến, thời gian đến thực tế, thời gian nhận hàng thực tế, thời gian dỡ hàng thực tế, thời gian thông báo đến thực tế, thời gian nhận hàng thực tế)',
  ViewShippingTracking: 'Nếu có nhiều chuyến bay khác nhau, vui lòng kiểm tra trang 【Theo dõi vận chuyển】',
  IntermediateAirline: 'Các hãng hàng không sửa đổi không có trong danh sách các hãng hàng không hỗ trợ đăng ký và sẽ không thể lấy dữ liệu chuyến bay thứ hai.',
  ExportingPleaseWait: 'Đang xuất tập tin, vui lòng chờ một chút',
  ExportTakePlaceInBackground: 'Bạn có thể rời khỏi trang và xuất sẽ diễn ra trong nền',
  CompletionDownloadMessageReminderInRightCorner: 'Khi hoàn thành, hãy đến góc trên bên phải."Thông điệp nhắc nhở"Đang tải xuống.',
  FileExportCompletionReminder: 'Nhắc nhở hoàn thành xuất tập tin',
  SyncPartnerToFinanceCodeReminder: 'Mã khách hàng Nhập hoàn thành nhắc nhở',
  NoNewPermissionsForFees: 'Không có phí Thêm quyền',
  NoPayChargesImport: 'Bạn không có quyền mới để tính phí, không có phí nhập khẩu',
  NoCostChargesImport: 'Bạn không có quyền phải trả phí mới, không có phí nhập khẩu',
  OnlyCostChargesImport: 'Bạn không có quyền mới để tính phí, chỉ nhập các khoản phí phải trả',
  OnlyPayChargesImport: 'Bạn không có quyền phải trả phí mới, chỉ nhập phí phải trả',
  ConfirmDeleteN: 'Xác nhận xóa bản ghi này?',
  AffiliatedBranchStyle: 'Phong cách chi nhánh trực thuộc',
  DisplayByOrganizationalStructure: 'Hiển thị theo cấu trúc tổ chức',
  AllDisplay: 'Hiển thị tất cả',
  FileView: 'Xem tập tin',
  NotPermissionToEditFilesByOtherUsers: 'Không đủ quyền hạn: Không có quyền chỉnh sửa các tập tin được tải lên bởi người dùng khác',
  NotMatchingTheCostOfTheProjectCanBeDelete: 'Không có khoản phí phù hợp để xóa.',
  ThisPartnerDoesNotSupportEnterReceivableFees: 'Đối tác này không hỗ trợ nhập phí phải thu',
  ThisPartnerDoesNotSupportEnterPayableFees: 'Đối tác này không hỗ trợ nhập chi phí phải trả',
  Can_Changed: 'Đơn hàng thay đổi',
  Customer_Service: 'Dịch vụ khách hàng',
  Documentation_Department: 'Bộ phận chứng từ',
  Countries_Regions_Destination: 'Cảng đích Quốc gia/Khu vực',
  CargoDocAndContainerQWTNotSame: 'Thông tin đóng gói B/L không phù hợp với thông tin đóng gói kinh doanh!',
  Some_Items_Have_Expired: 'Một số dự án thu phí đã hết hiệu lực, sao chép thất bại',
  SentDestinationPortAgentTip: 'Thời gian đã được gửi thông qua chức năng gửi một cú nhấp chuột',
  SendFileVerification: 'Gửi kiểm tra tập tin',
  SendFileVerificationSuccessTip: 'Xác minh tệp thành công, vui lòng nhấp vào 【Tiếp theo】 để tiếp tục gửi thư hoặc 【Tiếp theo】',
  SendFileVerificationExceptionTip: 'Ngoại lệ xác minh tệp, vui lòng nhấp vào 【Tiếp theo】 để tiếp tục gửi thư hoặc 【Hủy bỏ】',
  Validating: 'Kiểm tra trạng thái',
  MasterCheckExist: 'Kiểm tra vé chính: {0} Có tồn tại hay không',
  SmallCheckExist: 'Kiểm tra vé nhỏ: {0} Có tồn tại hay không',
  EmailAttachments: 'Thư đính kèm',
  DeleteAttachTip: 'Bạn chắc chắn muốn xóa file đính kèm này?',
  LocalEmailSentSuccess: 'Email địa phương gửi thành công?',
  LocalEmailTooLarge: 'Nội dung email quá lớn để nhảy vào hộp thư địa phương!',
  Lack: 'Thiếu',
  FileDragArea: 'Tải tập tin lên khu vực này',
  EnterKeyword: 'Nhập từ khóa',
  ClearSelectedItems: 'Tùy chọn nhà trống',
  ManifestFileNumBox: 'Số tập tin MANIFEST bằng số hộp',
  ManifestFileNumNotEqualBox: '【Số lượng hộp】: {0}/【MAINFIEST】 Số tệp: {1}, tệp MANIFEST và khối lượng hộp không phù hợp',
  TheSelectedDataIsIgnoredSuccessfully: 'Dữ liệu đã chọn Bỏ qua thành công',
  SelectedDataHasBeenBatchProcessedSuccessfully: 'Dữ liệu đã chọn Bỏ qua thành công',
  ThereAreNoNegligibleCosts: 'Không có chi phí bỏ qua',
  ThereAreNoFeesThatCanBeEliminated: 'Không có chi phí hủy bỏ bỏ qua',
  OnlyUnRead: 'Xem tin nhắn chưa đọc',
  AllMarksRead: 'Tất cả thẻ đã đọc',
  MessageConfig: 'Thiết lập tin nhắn',
  SaleProductCodeCannotBeNull: 'Sản phẩm bán được không được để trống',
  FullOrInsideCannotBeNull: 'Toàn bộ nội địa không được để trống',
  NotNullForMapping: 'Dấu trang cơ bản "Các trường [Sản phẩm có thể bán được] và [Toàn bộ/trong nước] không thể trống", vui lòng nhập trước khi chọn phí',
  DifferentJobOrBusinessFieldValues: 'Nhiều bài đăng khác nhau hoặc giá trị trường kinh doanh được bao gồm trong doanh nghiệp được chọn, khi không được thiết lập, bài đăng gốc và giá trị trường sẽ được giữ lại',
  PreserveOriginalValue: 'Giữ nguyên gốc',
  SelectSynchronizedFields: 'Chọn Sync Field',
  SynchronizedFields: 'Trường đồng bộ',
  RunSuccess: 'Chạy thành công',
  RunFail: 'Chạy thất bại',
  PleaseUpload: 'Giá trị gốc trống, vui lòng tải lên tệp',
  CodeTip: '1. Ngôn ngữ mã hoá ở đây: javascript' +
      'B5-05=giá trị thông số Kd, (cài 2)' +
      'Để có được phần tử đầu tiên, bạn có thể sử dụng: result[0] (phần tử bắt đầu đếm từ số 0)' +
      'Để có được giá trị của một trường nhận dạng, bạn có thể sử dụng: result[0].text.data[\'Đóng gói\']' +
      'Để thay đổi giá trị của gói, bạn có thể sử dụng: result[0].text.data[\'Đóng gói\'] =\'PPK\'' +
      'Thay thế tất cả các gói hàng"P"Các giá trị, bạn có thể sử dụng: result[0].text.data[\'Đóng gói\'] =result[0].text.data[\'Đóng gói\'].replaceAll(\'P\',\'B\');',
  BlIsIssued: 'B/L đã được phát hành',
  NoVirtualHBLTip: 'Không có hình thức thanh toán cho doanh nghiệp này, vui lòng kiểm tra hình thức thanh toán trước khi thực hiện thao tác',
  NoVirtualHBLAuthTip: 'Không có quyền kiểm tra trang này, xin vui lòng liên hệ với quản trị viên để cấu hình quyền truy cập sau khi sử dụng!',
  FieldValueCannotBeNull: 'Không thể để trống',
  ImportFailedFileNameNotMatch: 'Nhập không thành công, tên tập tin không bắt đầu với ISF5 hoặc ISF10',
  ISF5File: 'Mẫu ISF5',
  ISF10File: 'Mẫu ISF10',
  BookingLabel: 'Đăng ký trang',
  BatchPurchasePriceLock: 'Vui lòng đánh dấu vào các doanh nghiệp có giá mua không bị khóa để hoạt động.',
  BatchPurchasePriceUnLock: 'Vui lòng đánh dấu vào các doanh nghiệp có giá mua bị khóa để hoạt động.',
  BatchSellingPriceUnLock: 'Vui lòng đánh dấu các doanh nghiệp có giá bán bị khóa để hoạt động.',
  BatchSellingPriceLock: 'Vui lòng đánh dấu vào các doanh nghiệp có giá bán không khóa để hoạt động.',
  NotPermissionToViewFiles: 'Tập tin {0} tồn tại mà không có quyền xem và không thể gửi thư',
  ContainerTotalNeedEqual: 'Tổng số container 【Số lượng gói outsourcing】 【Số lượng mảnh đóng gói bên trong】 【Tổng trọng lượng】 【Trọng lượng tịnh】 cần phải phù hợp với tổng số trong số hàng hóa đặc biệt',
  PackingAddNotRepeat: 'Thông tin đóng gói đã chọn đã được thêm vào, đừng thêm lại',
  selectRequirement: 'Nhấp đúp để chọn yêu cầu hoạt động',
  DataGroup: 'Gói dữ liệu',
  CloseRefreshNeedMannulUpdate: 'Khi tắt tính năng làm mới tự động, cần có một cú nhấp chuột của con người 【Làm mới】 để cập nhật dữ liệu!',
  RefreshRule: 'Quy tắc làm mới:',
  NodeRecord: 'Bản ghi nút:',
  HomePageNotRefreshData: 'Không tự động làm mới dữ liệu khi vào trang đầu',
  DisplayLastClickNode: 'Hiển thị các nút được nhấp lần cuối',
  RetainQueryCondition: 'và giữ lại các điều kiện truy vấn cho nút đó',
  N0VerificationPassed: '【{0}】 Xác nhận',
  ConsigneeCompanyName: 'Tên doanh nghiệp của người nhận hàng',
  TaskBoard: 'Nhiệm vụ Kanban:',
  AlertNode: 'Các nút cảnh báo:',
  DoOfQueryResultsTemplates: 'Không hiển thị theo số lượng kết quả truy vấn, đặt lại điều kiện truy vấn khi chuyển đổi mẫu',
  SendPortAgentByNumber: 'Gửi đại lý cảng đích - theo số hộp',
  SendAgentByCaseNumber: 'Gửi bộ đại lý - theo số hộp',
  SetOrderAgency: 'Bộ đại lý đơn',
  LastSentTime: 'Lần gửi cuối',
  Russian: 'Tiếng Nga',
  Vietnamese: 'Tiếng Việt',
  Thai: 'Tiếng Thái',
  SelectTransshipmentStatusErrorPrompt: 'Chỉ hỗ trợ sửa đổi hàng loạt cho nghiệp vụ thao tác tích cực.',
  NoAccessPermission: 'Không có quyền truy cập'
}
